{
    "ariaLabel": {
        "viewDetails": "查看详情",
        "downloadDataAssets": "下载数据资产"
    },
    "topMenu": {
        "dihTitle": "数据智能枢纽",
        "DIHOrgRegistration": "数据智能枢纽 - 组织注册",
        "dihSubTitle": "安全地从数据中提取价值",
        "logout": "退出登录",
        "myAccount": "我的账户",
        "myOrganization": "我的组织"
    },
    "userLogoutAlert": {
        "title": "您确定要退出登录吗？",
        "back": "返回",
        "logout": "退出登录",
        "myOrganization": "我的组织"
    },
    "sideMenu": {
        "dashboard": "仪表板",
        "connectors": "连接器",
        "myConnectors": "我的连接器",
        "dataspaces": "数据空间",
        "discover": "发现",
        "manage": "管理",
        "marketplace": "市场",
        "myDataspaces": "我的成员资格",
        "browseDataspaces": "浏览数据空间",
        "organizations": "组织",
        "build": "构建",
        "ownedDataspaces": "我的数据空间",
        "collapse": "折叠侧边栏",
        "participate": "参与",
        "getVerified": "获取验证",
        "workbench": "工作台",
        "dataIncoming": "数据输入",
        "applications": "应用程序",
        "verify": "验证",
        "digitalIDDashboard": "获取洞察",
        "mySignatures": "我的签名",
        "externalConnectionManager": "外部连接管理器"
    },
    "dropdown": {
        "selectAll": "全选",
        "noOption": "无可用选项",
        "noSuchOption": "没有这样的选项..."
    },
    "common": {
        "start": "开始",
        "finish": "完成",
        "firstName": "名字",
        "lastName": "姓氏",
        "email": "电子邮件地址",
        "phoneNumber": "电话号码",
        "contactPerson": "联系人",
        "welcome": "欢迎",
        "street": "街道",
        "city": "城市",
        "region": "地区",
        "country": "国家",
        "postCode": "邮政编码",
        "number": "号码",
        "next": "下一步",
        "prev": "返回",
        "alreadyAccount": "已有账户？",
        "login": "登录",
        "loginNow": "立即登录",
        "register": "注册",
        "home": "主页",
        "submit": "提交",
        "attention": "注意",
        "desc": "描述",
        "website": "网站",
        "contact": "联系",
        "details": "详情",
        "plan": "计划",
        "listView": "列表视图",
        "gridView": "网格视图",
        "firstPage": "第一页",
        "previousPage": "上一页",
        "nextPage": "下一页",
        "lastPage": "最后一页",
        "download": "下载",
        "delete": "删除",
        "edit": "编辑",
        "information": "信息",
        "organization": "组织",
        "cancel": "取消",
        "save": "保存",
        "upload": "上传",
        "link": "链接",
        "view": "查看",
        "search": "搜索",
        "searchTerm": "搜索",
        "selectOption": "选择一个选项",
        "sortBy": "排序方式",
        "dataspace": "数据空间",
        "select": "选择",
        "date": "日期",
        "title": "标题",
        "successful": "成功",
        "unsuccessful": "失败",
        "statuses": {
            "connected": "已连接",
            "disconnected": "已断开",
            "deploying": "部署中",
            "deployed": "已部署",
            "failed": "失败",
            "available": "可用",
            "success": "成功",
            "active": "活跃",
            "pending": "待定",
            "declined": "已拒绝",
            "invited": "已邀请",
            "onboarding": "入职中",
            "withdrawn": "已撤回",
            "successful": "成功",
            "unsuccessful": "失败",
            "valid": "有效",
            "expired": "已过期",
            "revoked": "已撤销",
            "inprogress": "进行中",
            "rejected": "拒绝",
            "inactive": "无效",
            "subscribed": "已订阅"
        },
        "andMore": "以及其他 {count} 项",
        "confirm": "确认",
        "yes": "是",
        "no": "否",
        "links": {
            "dihWiki": "https://docs.dih.telekom.com/zh/home"
        },
        "formError": "出现错误。",
        "question": {
            "interested": "感兴趣？"
        },
        "moreInfo": "如果您需要更多信息: ",
        "goToWebsite": "访问我们的网站",
        "provider": "提供者",
        "required": "必填",
        "errors": "错误",
        "error": "错误",
        "from": "从",
        "to": "到",
        "openLinkInNewTab": "在新标签页中打开链接",
        "formatError": "格式无效。请检查您的输入，然后重试",
        "ID": "ID"
    },
    "genericError": "哦,出了点问题！请再试一次。",
    "validation": {
        "fieldRequired": "{field} 是必填项。",
        "fieldNumeric": "{field} 只能包含数字。",
        "fieldAlpha": "{field} 只能包含字母、_ 和 -。",
        "fieldAlphanumeric": "{field} 只能包含字母、数字、_ 和 -。",
        "fieldNumericDash": "{field} 只能包含数字和 -。",
        "fieldHouseNumber": "{field} 只能包含数字、字母,以及字符 - 和 /。",
        "fieldPhoneNumber": "{field} 只能包含数字和 -。必须以 + 或 00 开头。",
        "fieldAlphaDash": "{field} 只能包含字母和 -。",
        "exceptHTMLTagBrackets": "字段 {field} 不得包含以下字符：^<>",
        "alphaNumericExtended": "{field} 字段只能包含字母、数字、-、/、# 和 .",
        "ipOrCidrRegex": "该值必须是有效的 IP 地址",
        "isMaxLength": "超过最大长度 10 个字符。",
        "emailFormat": "电子邮件地址格式错误",
        "fileSizeError": "文件大小超过 {size} MB。",
        "csvFileSizeError": "此文件过大。您最多可以上传 {size} MB 的文件。",
        "csvFileExtensionError": "只允许上传 CSV 扩展名的文件。",
        "csvFileIsEmptyError": "此文件为空。您需要上传至少 {size} KB 的文件。",
        "csvFileFormatError": "文件格式不符合预期。请使用提供的模板并重试。",
        "uploadFails": "上传失败",
        "fileExtensionError": "文件扩展名不适用",
        "fileIsMalwareInfectedError": "此文件似乎包含恶意软件。出于安全原因,无法上传此文件。请再次检查您的文件",
        "customValidation": "{field} 格式错误。",
        "selectCountryFirst": "请先选择国家名称",
        "validationPostCodeCaseDE": "字段格式错误。必须包含 5 位数字,例如: 53113",
        "validationAlphanumericCase": "字段只能包含字母数字字符、破折号和下划线。值必须以字母数字字符开头。",
        "validationNumericDashCase": "字段只能包含数字和 -。",
        "url": "请输入有效的 URL",
        "maxInvitationSize": "您一次最多可以邀请 {size} 位参与者",
        "errorUploadingFile": "上传文件时出错。请重试。",
        "password": {
            "passwordStrength": "密码强度",
            "weak": "弱",
            "average": "中等",
            "strong": "强",
            "passwordValidationMoreChar": "至少 {count} 个字符",
            "passwordUpperAndLowerChar": "大写和小写字母",
            "passwordAtLeastNumber": "至少一个数字",
            "passwordAtLeastSpecialChar": "至少一个特殊字符（不包括 <>&\"`[]）",
            "passwordDiffFromPrev": "与您之前的密码不同"
        },
        "orgName": "{field} 只能包含字母、数字、_、- 和 &。",
        "tagLimitMessage": "您最多只能添加 {count} 个用例。"
    },
    "footer": {
        "tagLine": "让我们共同提升性能",
        "imprint": "版权信息",
        "imprintShort": "版权信息",
        "imprintLink": "https://dih.telekom.com/zh/imprint",
        "contact": "联系",
        "contactLink": "https://dih.telekom.com/zh/contact",
        "termsAndConditions": "条款与条件",
        "privacy": "隐私政策",
        "privacyShort": "隐私政策",
        "telekom": "T-Systems International GmbH。保留所有权利。",
        "telekomShort": "T-Systems International GmbH",
        "note": "Telekom 数据智能枢纽 - 仅供企业客户使用",
        "brandedNote": "由 Telekom 数据智能枢纽提供支持",
        "help": "帮助",
        "cookieSettings": "饼干 设置",
        "cookieSettingsShort": "饼干",
        "life": "分享生活"
    },
    "onboarding": {
        "welcome": "欢迎来到数据智能中心",
        "welcomeDIH": "欢迎来到数据智能中心",
        "thankYouEnterprise": "感谢您选择连接和集成企业",
        "informationForOrganization": "您的组织信息",
        "orgNameLabel": "组织名称",
        "orgUnitNameLabel": "组织单位名称",
        "emailAddressLabel": "电子邮件地址",
        "countryNameLabel": "国家",
        "bpnNumberLabel": "业务合作伙伴编号（BPN）",
        "contactPersonInfo": "联系人信息",
        "fillInfoBelow": "请填写以下信息",
        "orgRegNameLabel": "组织/单位的注册名称",
        "legalNameHint": "请输入您组织的法定名称",
        "addressHeading": "组织总部地址",
        "PLZCode": "邮政编码",
        "verifyEmail": "验证电子邮件",
        "verifyEmailMessage": "感谢您加入数据智能中心——您的组织已在我们这里注册。请验证您的电子邮件。",
        "taxId": "增值税号",
        "commerceRegisterNumber": "商业注册号",
        "orgRepresentative": {
            "title": "设置您的组织代表账户",
            "orgContactPerson": "组织联系人",
            "whatDefinesYou": "您最符合以下哪项描述？",
            "agreeText": "我确认我已阅读并将遵守数据智能中心的{1}",
            "confirmText": "我同意根据<a href='#'>数据隐私声明</a>存储和处理我的个人数据"
        },
        "success": "组织注册成功",
        "underReview": "您的组织正在验证中。",
        "verified": "您已成功验证您的组织",
        "month": "月 | 月 | {count} 个月",
        "steps": {
            "counter": {
                "step": "步骤",
                "of": "共"
            },
            "stepWizard": {
                "orgInfo": "组织信息",
                "selectConnection": "选择您的连接",
                "configureConnection": "配置您的连接",
                "selectPackage": "选择您的计划",
                "checkout": "结算",
                "enterpriseTitle": "我们会尽快回复您",
                "enterpriseSubtitle": "在此期间，请向我们提供更多详细信息，以便我们更好地帮助您。"
            },
            "actionButton": {
                "back": "返回",
                "next": "下一步",
                "order": "下订单并付款",
                "checkout": "结算",
                "selectMyPlan": "选择我的计划",
                "submitRequest": "提交请求",
                "editModeDisabled": "现有订单未进行任何更改。"
            },
            "orgStep": {
                "fields": {
                    "orgInfoLabel": "组织详细信息",
                    "dataSpaceAttributes": "附加属性",
                    "orgName": "组织法定名称",
                    "departmentName": "部门名称",
                    "crnNumber": "商业注册号",
                    "taxId": "增值税号",
                    "bpnNo": "业务合作伙伴编号（BPN）",
                    "addressInfo": "账单地址",
                    "countryName": "国家",
                    "plzCode": "邮政编码",
                    "number": "门牌号",
                    "city": "城市",
                    "street": "街道",
                    "contactPersonLabel": "联系人",
                    "fullName": "全名",
                    "firstName": "名字",
                    "firstNamePlaceholder": "输入您的名字",
                    "lastName": "姓氏",
                    "lastNamePlaceholder": "输入您的姓氏",
                    "contactPerson": "联系人",
                    "phoneNo": "电话号码",
                    "emailAdd": "电子邮件地址",
                    "dataPrivacyCheck": "我同意根据{dataprivacystatement}和{supplementaryDataPrivacyConditions}存储和处理我的个人数据",
                    "dataPrivacyCheckNew": "我同意按照{dataprivacystatement}存储和处理我的个人数据。",
                    "termsAndConditionsCheck": "我确认,作为公司授权代表,我已阅读、理解并接受{termsandcondition}。",
                    "dataprivacystatement": "数据隐私声明",
                    "supplementaryDataPrivacyConditions": "补充数据隐私条件",
                    "termsandcondition": "条款和条件",
                    "agreeToEnterContract": "我同意根据{serviceDescription}与T-Systems International GmbH签订合同",
                    "serviceDescription": "服务描述",
                    "markettingConsentCheck": "我同意接收T-Systems International GmbH和Telekom Deutschland GmbH关于产品、服务和活动的营销电子邮件、信件、电话或短信/MMS。我可以随时通过发送电子邮件至{email}撤销此同意"
                }
            },
            "connection": {
                "sectionHeading": "选择您的连接",
                "sectionSubHeading": "请选择您在{dsName}的数据空间的连接类型",
                "textNote": "只能选择与Catena-X兼容的选项",
                "recommendedConfiguration": "推荐配置",
                "cloudProvider": "云服务提供商",
                "cloudProviderTooltip": "此订阅推荐的云服务提供商",
                "contactSales": "联系销售"
            },
            "packages": {
                "sectionHeading": "选择您的计划",
                "sectionSubHeading": "数据计划变体",
                "basedOnYourSelection": "根据您的选择,我们推荐以下内容",
                "dataPackage": "数据包",
                "outgoingTraffic": "出站流量",
                "storage": "存储",
                "selectedDataPlan": "选择数据计划",
                "dataPlanDetails": "数据计划详情",
                "dataPlanLabelForVolume": "包含流量的计划",
                "dataPlanLabelFlexible": "按需付费",
                "packageAvailable": "此套餐仅适用于此计划",
                "chargesApply": "如果使用量超过流量限制,将收取费用",
                "additionalStorage": "额外存储",
                "additionalTraffic": "额外出站流量",
                "oneTimeSetUpCharges": "一次性设置费用",
                "starterKit": "入门套件",
                "starterKitTooltip": "轻松设置您的环境,包括技术访问配置、账户创建、功能测试和知识库集成。有关详细信息,请参阅结算过程中提供的服务描述",
                "onboardingKit": "入职套件",
                "onboardingKitTooltip": "灵活的小时咨询套餐,旨在为实施数据空间解决方案提供量身定制的支持,由我们专业团队提供。有关详细信息,请参阅结算过程中提供的服务描述。",
                "pleaseSelectYourDesiredContractDuration": "请选择您期望的合同期限",
                "subscriptionTitle": "连接显示名称",
                "subscriptionTitleLabel": "输入连接显示名称",
                "automatedIntegrationCapabilities": "自动集成功能",
                "automatedIntegrationCapabilitiesTooltip": "自动集成功能为您提供额外的功能,以实现与数据空间的半自动集成。这些功能包括数据映射、低代码数据转换等。",
                "boschDtrTitle": "寻找博世的高性能数字孪生注册表？",
                "optional": "可选",
                "boschDtrDescription": "博世提供数字孪生注册表 (DTR),这是一个数字目录,可实现数百万数字孪生的快速识别和检索,促进其创建、分配、存储和删除。请点击下面的复选框,我们的销售团队将很乐意为您提供帮助。",
                "boschDtrLearnMore": "了解更多",
                "boschDtrContactSaleCheck": "我希望T-Systems International GmbH的销售团队与我联系"
            },
            "zoneSelection": {
                "zoneSelectionTitle": "你希望你的数据存放在哪里？",
                "zoneSelectionTooltip": "选择你希望数据存放的区域。"
            },
            "cloudProviders": {
                "cloudInfrastructure": "选定区域内的哪个云服务提供商？",
                "toolipContent": "选择最适合您需求的云服务提供商。",
                "cloudAvailable": "此套餐仅适用于此云服务提供商"
            },
            "checkout": {
                "sectionHeading": "您的连接套餐: {orgName}",
                "setupCost": "设置费用",
                "monthlyCost": "每月费用",
                "payg": "按需付费",
                "pipSheet": "产品信息表",
                "totalCost": "总费用",
                "totalPayable": "应付总金额",
                "dataPrivacyCheck": "我同意支付上述所订服务相关的费用",
                "termsAndConditionsCheck": "我同意合同期限和取消政策",
                "termsandcondition": "条款与条件",
                "EOMAmountPolicy": "我接受应付总金额将在月底计算",
                "generalAgreement": "我同意根据上述服务描述与 T-Systems International GmbH 签订合同",
                "DPAAgreement": "我同意 {dataprocessingagreement} (DPA)",
                "dataprocessingagreement": "数据处理协议",
                "dataPackage": "数据套餐",
                "dataPlan": "数据计划",
                "outgoingTraffic": "包含的出站流量",
                "storagePrice": "存储价格",
                "perGigabyteForStorage": "/GB 存储",
                "perGigabyteForOutgoingTraffic": "/GB 出站流量",
                "outgoingTrafficPrice": "出站流量价格",
                "contractDuration": "合同期限",
                "contractDurationIconTooltip": "根据您的需求选择合同期限",
                "contractDurationTooltip": "此订阅推荐的合同期限",
                "defaultContractDuration": "6 个月",
                "price": "价格",
                "perGigabyte": "每 GB",
                "monthlyCancelable": "每月可取消",
                "storage": "包含的存储空间",
                "linksText": {
                    "information": "信息表",
                    "service": "服务描述"
                },
                "plusCharges": "{plus} 消耗费用",
                "plus": "额外",
                "basedOnConsumption": "按消耗计费",
                "selectedConfiguration": "所选配置",
                "oneTimeCosts": "一次性费用",
                "connectionType": "连接类型",
                "dataIntegrationLevel": "数据集成级别",
                "addOns": "附加功能",
                "connectors": "连接器",
                "totalUseCases": "用例总数",
                "totalAmount": "总金额",
                "supplementaryDataPrivacyConditionsCheck": "我同意根据 {supplementaryDataPrivacyConditions} 储存和处理我的个人数据",
                "supplementaryDataPrivacyConditions": "补充数据隐私条款",
                "withIncludedVolume": "包含流量",
                "cloudProvider": "云服务提供商",
                "selectedZone": "区域",
                "additionalCharges": "*如果您超出每月配额,将收取额外费用",
                "semiAutomatedApiCapability": "半自动,具有 API 功能",
                "manualApiCapability": "手动,具有 API 功能"
            },
            "useCases": {
                "title": "选择您的用例",
                "tagText": "每增加一个用例,每月费用为 100€。",
                "bodyText": "请选择您参与 Catena-X 的用例。您至少需要选择一个；第一个用例已包含在您的订阅中。您可以根据需要选择多个,每增加一个用例将额外收取 100€ 的费用。"
            },
            "cancelModal": {
                "confirmQuestion": "您确定要取消所选连接吗？",
                "confirmYes": "是的,取消",
                "confirmNo": "不,继续"
            },
            "enterprisePackage": {
                "inputTitle": "消息",
                "inputPlaceholder": "开始输入",
                "emptyErrorMessage": "消息不能为空或只有空格",
                "validCharErrorMessage": "消息包含无效字符",
                "noURLsErrorMessage": "消息不能包含链接或 URL",
                "limitRepeatsErrorMessage": "消息包含过多的重复字符"
            }
        },
        "statuses": {
            "complete": {
                "title": "您已完成注册",
                "description": "该注册链接已无法再次使用。",
                "buttonText": "返回首页"
            },
            "error": {
                "title": "出现了一些问题",
                "description": "请重新开始流程",
                "buttonText": "重新开始"
            },
            "expired": {
                "title": "很抱歉,您的链接已过期",
                "description": "请从 Catena-X 门户重新开始流程。",
                "buttonText": "返回 Catena-X"
            },
            "success": {
                "title": "感谢您的注册",
                "description": "我们正在审核您组织的详细信息。您将通过电子邮件收到进一步的信息。",
                "buttonText": "前往我们的网站"
            },
            "invalid": {
                "title": "未经授权",
                "description": "您无权访问此页面。",
                "buttonText": "前往我们的网站"
            },
            "dih-success": {
                "title": "感谢您的注册",
                "description": "我们正在审核您组织的详细信息。您将通过电子邮件收到进一步的信息。",
                "buttonText": "前往我们的网站"
            },
            "orgNotFound": {
                "title": "我们无法找到您的组织",
                "descriptionLine1": "抱歉！看起来您的组织尚未入驻,或尚未申请 T-Systems 的服务订阅。",
                "descriptionLine2": "请通过 {marketplace} 申请 T-Systems 认证的 Catena-X 定制支持服务订阅。",
                "marketplace": "市场平台",
                "descriptionLine3": "如果您认为这是一个错误,请 {contactOurSalesTeam},我们将很乐意为您提供支持。",
                "contactOurSalesTeam": "联系销售团队",
                "exploreTheKnowledgeBase": "浏览知识库",
                "readOurBlog": "阅读我们的博客"
            },
            "ds-success": {
                "title": "感谢您的订购",
                "description": "我们已成功接收到您组织的详细信息。",
                "descriptionPara2": "我们正在审核信息,并将通过电子邮件尽快与您联系。",
                "buttonText": "开始使用"
            }
        },
        "orgExistLogin": {
            "title": "已经拥有 Data Intelligence Hub 账户？",
            "action": "登录",
            "error": {
                "permissionErrorTitle": "您没有访问此页面所需的权限。",
                "permissionErrorText": "请联系您的组织管理员以获取更多信息",
                "orgNotFoundTitle": "未找到组织",
                "orgNotFoundText": "我们无法从您的电子邮件地址识别您的组织。请填写注册表并提供您的订单信息。"
            }
        },
        "newOnboarding": {
            "address": {
                "country": "国家*",
                "region": "地区*",
                "street": "街道*",
                "number": "门牌号*",
                "postCode": "邮政编码*",
                "city": "城市*",
                "organisationAddress": "组织地址",
                "organisationAddressSubheading": "请输入您的组织地址",
                "billingAddress": "账单地址",
                "billingAddressSubheading": "请输入您的账单地址",
                "sameAsOrgAddress": "我的账单地址与组织地址相同。"
            },
            "organisationInformation": "组织信息",
            "organisationInformationSubheading": "请输入您的组织信息",
            "organisationName": "组织法定名称",
            "organisationNameInfo": "请输入组织的具有法律效力的名称",
            "transliteratedName": "音译名称 (拉丁字符)",
            "transliteratedNameInfo": "可选：请使用拉丁字母输入名称，以帮助我们的审核人员。这不必是正式名称。",
            "transliteratedNamePrompt": "您的法定姓名使用的是非拉丁文字。请考虑提供拉丁字母的音译，以便协助我们的审核人员。",
            "transliteratedNameValidationMsg": "请提供拉丁字母的音译，以便我们的审核人员参考。",
            "contactDetailsHeading": "联系信息",
            "contactDetailsSubheading": "请输入您的联系方式",
            "firstName": "名字*",
            "lastName": "姓氏*",
            "emailAddress": "电子邮件地址*",
            "phoneNumber": "电话号码*",
            "companyIdentifierHeading": "组织标识符",
            "companyIdentifierSubheading": "输入以下至少一个唯一 ID 以继续*",
            "identifierType": "标识符类型*",
            "identifierValue": "标识符值*",
            "identifierTypeError": "请选择标识符类型",
            "identifierValueError": "标识符值是必需的",
            "identifierValueFormatError": "格式无效。示例：{field}"
        }
    },
    "dashboard": {
        "pageTitle": "你好",
        "pageSubtitle": "这是您在数据智能中心的控制中心。"
    },
    "services": {
        "finishConfig": "完成配置",
        "open": "打开",
        "viewDetails": "查看详情",
        "configure": {
            "uploadCertification": "请上传您从数据空间运营商处收到的证书。",
            "dragAndDropCertificate": "将证书文件拖放到此处。",
            "didntReceive": "没有收到证书或不知道如何获取？请按此步骤操作",
            "uploadSuccessMessage": "证书上传成功"
        },
        "table": {
            "attribute": "属性",
            "value": "值",
            "apiKey": "API 密钥",
            "apiKeyValue": "API 密钥值",
            "controlPlaneUrl": "控制平面 URL",
            "idsURL": "DSP API 端点",
            "connectorUrl": "连接器 URL",
            "dataManagementUrl": "数据管理 API 端点",
            "dataDashboard": "数据仪表板",
            "participantDid": "参与者 DID ID"
        }
    },
    "dataspaces": {
        "dataspaces": "数据空间",
        "viewAllDataspaces": "查看所有数据空间",
        "managedConnectorsHeading": "托管连接器",
        "externalConnectorsHeading": "外部连接器",
        "connectorTestDescription": "用于测试您的连接是否按预期运行,且与数据空间的连接是否处于激活状态的应用。",
        "configure": {
            "pageTitle": "配置数据空间连接",
            "basicInfo": "基本信息",
            "certificate": "证书",
            "instructionCertrificate": "请上传您从数据空间运营商处收到的证书。"
        },
        "connectorHealthCheck": {
            "title": "连接器健康检查",
            "copiedToClipboard": "已复制到剪贴板",
            "description": "此应用可执行自检,检查您选择的连接器是否配置正确且运行正常。此操作不会更改任何连接器的设置或存储。",
            "connectorid": "连接器 ID",
            "model": {
                "title": "连接器健康检查进行中...",
                "body": "健康检查进行时,您不能离开此页面。若您选择离开,检查将终止,需重新启动。",
                "toLeave": "不,我想离开",
                "toFinish": "完成健康检查"
            },
            "banner": {
                "initiate": "健康检查可能需要几分钟完成。结果一旦可用,您将收到通知。",
                "success": "您的连接自检成功！要查看过去的测试结果,请点击上方的结果。",
                "failed": "抱歉！您的连接自检失败。请联系 {email},我们将乐意为您提供支持。",
                "email": "dih.support{'@'}telekom.com"
            },
            "buttonState": {
                "initiate": "启动",
                "success": "打开连接",
                "failed": "联系支持",
                "back": "返回"
            }
        },
        "browse": {
            "browseDataspace": "浏览数据空间",
            "availableDS": "可用数据空间",
            "howToConnect": "如何连接",
            "getConnected": "连接数据空间",
            "requestConnection": "请求连接",
            "viewRequest": "查看请求",
            "viewDetails": "查看详情",
            "highlightNote": "若您想管理与 {selectedDataspaceName} 的会员关系,请联系我们的支持团队: ",
            "uncoverByInvitation": "通过邀请访问",
            "dataspaceDetails": "数据空间详情",
            "participantOverview": "参与者概览",
            "services": "服务",
            "networking": "人脉",
            "networkingDesc": "该数据空间可能通过允许的IP地址范围限制网络对其服务和连接器的访问。如果您的应用出现问题，请联系您的数据空间管理员，将当前IP地址/范围加入白名单。",
            "networkingIPTitle": "我的IP地址（浏览器）",
            "networkingInfoText": "如果你的应用程序运行在另一台设备上，你可以登录该设备并发出类似这样的命令。",
            "networkingCurlCommand": "“curl --location 'ifconfig.me/ip”",
            "networkingHighlightNote": "如有任何疑问，请联系我们的支持：",
            "joinRequestSuccessTitle": "您加入 {dataspaceName} 的请求已提交",
            "joinRequestSuccessBody": "您的请求正在处理,稍后会有进一步通知",
            "dataspaceMembershipId": "Dataspace 会员编号",
            "uncover": {
                "title": "通过邀请展示数据空间",
                "subtitle": "您要查找哪个数据空间？",
                "fieldLabels": "请输入数据空间运营商提供的详细信息",
                "sendRequest": "发送请求",
                "back": "返回",
                "dataspaceId": "数据空间 ID",
                "password": "密码"
            },
            "requestDetailsModal": {
                "withdraw": "撤回",
                "cancel": "取消",
                "update": "更新",
                "withdrawConfirmationHeading": "撤回数据空间加入请求",
                "withdrawConfirmationBody": "请确认您是否确实要撤回加入数据空间 {dataspaceName} 的请求。",
                "notification": {
                    "withdrawSuccessfulTitle": "数据空间加入请求已撤回",
                    "withdrawSuccessfulBody": "您加入 {dataspaceName} 的请求已被撤回。",
                    "updateSuccessfulTitle": "数据空间加入请求已更新",
                    "updateSuccessfulBody": "您加入 {dataspaceName} 的请求已更新。"
                }
            }
        },
        "user": {
            "myMemberships": "我的会员资格",
            "enterDS": "进入数据空间",
            "registeredDS": "您的数据空间",
            "noMembership": {
                "title": "您还没有任何会员资格",
                "description": "浏览数据空间以加入",
                "actionButtonText": "连接数据空间"
            }
        },
        "statuses": {
            "attentionRequired": "需要注意",
            "comingSoon": "即将上线",
            "connected": "已连接",
            "disconnected": "已断开",
            "deploying": "部署中",
            "deployed": "已部署",
            "failed": "失败",
            "available": "可用",
            "success": "成功"
        }
    },
    "verify": {
        "orgProfile": "组织简介",
        "legalName": "法人名称",
        "address": "地址",
        "contact": "联系方式",
        "vatID": "增值税号",
        "requestChange": "请求更改",
        "downloadVCMessage": "凭证下载成功",
        "placeholderEnterSelectInput": "输入或从列表中选择值",
        "vcOverview": {
            "masterHeading": "凭证类型",
            "credentialTypeCards": {
                "description": {
                    "legalPerson": "这是法人信息的数字化表示,例如组织的注册详情、营业识别或法律状态",
                    "serviceOffering": "这是服务提供者组合成套餐,向消费者提供的资产和资源集合",
                    "physicalResource": "这是具有可测量重量和空间位置的资源,代表作为主机、操作者或与其他实体交互的实体",
                    "softwareResource": "这是一种包含非物理功能的资产类型,如源代码",
                    "dataResource": "这是一种以任何形式存在的数据资产（包括派生数据）,包含数据共享所需的信息"
                },
                "cta": {
                    "enter": "进入"
                }
            },
            "credentialOverview": "凭证概览",
            "credentialErrorMessage": "获取{type}凭证时出错",
            "searchByNamePlaceholder": "按名称搜索",
            "credentialErrorDetailsMessage": "当前获取凭证遇到技术问题,请稍后再试"
        },
        "verifiableCredentials": {
            "getVerified": "获取认证",
            "credentials": "凭证",
            "requestCredential": "请求凭证",
            "whichTypeToSelect": "我应该选择哪种类型？",
            "noCredentialsMessage": "您尚无{type}凭证",
            "credentialInfoMessage": "添加凭证将提升您在生态系统参与者中的信任度。",
            "credentialModalMessage": "您的凭证是确立公司身份、专业能力或合法性的资格或信息。",
            "learnMore": "了解更多",
            "status": {
                "all": "全部",
                "valid": "有效",
                "expired": "已过期",
                "revoked": "已撤销"
            },
            "types": {
                "legalPerson": "公司身份",
                "serviceOffering": "合规与认证",
                "physicalResource": "实体资源",
                "dataResource": "数据资源",
                "softwareResource": "软件资源",
                "membership": "会员资格"
            },
            "form": {
                "type": {
                    "placeholder": "选择您的凭证类型",
                    "label": "凭证类型",
                    "error": "凭证类型为必填项"
                },
                "types": {
                    "legalPerson": "法人",
                    "serviceOffering": "服务提供",
                    "resource": "资源",
                    "physicalResource": "实体资源",
                    "dataResource": "数据资源",
                    "softwareResource": "软件资源"
                },
                "companyInformationSectionTitle": "公司信息",
                "companyInformationSectionSubtitle": "请输入您的公司信息",
                "legalName": {
                    "label": "组织法人名称",
                    "helpText": "请使用组织的法定名称"
                },
                "country": {
                    "placeholder": "选择国家",
                    "label": "国家",
                    "error": "国家为必填项"
                },
                "region": {
                    "placeholder": "选择地区",
                    "label": "地区",
                    "error": "地区为必填项"
                },
                "street": {
                    "label": "街道和门牌号"
                },
                "city": {
                    "label": "城市"
                },
                "postalCode": {
                    "label": "邮政编码"
                },
                "commercialIdentificationSectionTitle": "商业识别",
                "commercialIdentificationSectionSubtitle": "请输入至少一个以下唯一标识以继续*",
                "CRN": {
                    "label": "商业登记号",
                    "helpText": "示例: HRB 55933",
                    "tooltipText": "商业登记号（CRN）是分配给公司的唯一标识,用于验证公司的注册和财务交易的真实性。"
                },
                "vatId": {
                    "label": "增值税号",
                    "helpText": "示例: DE 118 645 675",
                    "tooltipText": "增值税号是分配给企业用于税务的唯一识别码。"
                },
                "eori": {
                    "label": "EORI",
                    "helpText": "示例: DE 103 280 493 572",
                    "tooltipText": "EORI 是欧盟内从事国际贸易的经济运营者的注册识别号码。"
                },
                "lei": {
                    "label": "LEI",
                    "helpText": "示例: 5299009D9BIL4D4UHT93",
                    "tooltipText": "LEI 是分配给参与全球金融市场交易的法人实体的唯一识别代码。"
                },
                "didSectionTitle": "去中心化标识符 (DID)",
                "didSubSectionTitle": "如果您没有DID,请保持此字段为空,系统将自动生成。",
                "did": {
                    "label": "凭证主体(DID)",
                    "helpText": "did:example123456789abcd",
                    "tooltipText": "DID 是可解析为DID文档的唯一标识符,是去中心化数字身份的基础。"
                },
                "certificate": {
                    "error": "证书为必填项"
                },
                "request": "请求",
                "requesting": "请求中...",
                "certificateSectionHeading": "签名",
                "certificateSectionTitle": "您想使用哪个证书进行签名？",
                "addCertificate": "添加新证书",
                "chooseCertificate": "选择您的证书",
                "tsystemsCertificate": "T-Systems证书",
                "yourCertificate": "您的证书",
                "consentTooltip": "选中此项即允许T-Systems代表您签署上述文件。详情请查阅文档。",
                "consentPersonalData": "我特此同意并确认上述个人信息和数据（'个人数据'）的准确性。",
                "consentProcessing": "我特此同意并授权Gaia-X处理我的所有数据 (包括任何个人敏感数据）。"
            },
            "vcRequestSuccess": "请求已成功提交",
            "selectAllButton": "全选",
            "deselectAllButton": "取消全选",
            "revokeButton": "撤销",
            "searchboxPlaceholder": "请输入至少3个字符",
            "credentialTile": {
                "issuedBy": "颁发机构",
                "issuedOn": "颁发日期",
                "expiresOn": "有效期至",
                "expiredOn": "已过期",
                "viewDetailsButton": "查看详情"
            },
            "revokeModal": {
                "heading": "撤销确认",
                "question": "您确定要撤销该项吗？",
                "note": "注意: ",
                "message": "撤销凭证后,该凭证将失效且无法再使用。您需要重新请求新的凭证以获得有效凭证。",
                "primaryButton": "撤销",
                "secondaryButton": "取消"
            },
            "deleteCredential": {
                "heading": "删除确认",
                "question": "您确定要删除凭证吗？",
                "deleteSuccess": "已成功删除凭据"
            },
            "credentialsDetailsModal": {
                "heading": "凭证详细信息",
                "selfDescriptionCredential": "自我描述凭证",
                "type": "类型",
                "id": "id",
                "issuer": "发行者",
                "issuanceDate": "issuanceDate",
                "expirationDate": "expirationDate",
                "credentialSubject": "credentialSubject",
                "bpn": "ctxsd：bpn",
                "participantName": "gx-参与者：名称",
                "participantNameLegalName": "gx-参与者：合法名称",
                "legalRegistrationNumber": "gx：参与者：legalRegistrationNumber",
                "EUID": "gx：EUID",
                "leiCode": "gx：leiCode",
                "vatID": "gx：vatID",
                "registrationNumberType": "gx：注册编号类型",
                "registrationNumberNumber": "gx：注册编号",
                "headquarterAddress": "gx：参与者",
                "addressCountryCode": "gx：地址国家/地区代码",
                "countrySubdivisionCode": "gx：countrySubdivisionCode",
                "locality": "gx：locality",
                "streetAddress": "gx：streetAddress",
                "legalAddress": "gx：参与者：legalAddress",
                "termsAndConditions": "gx-参与者：termsAndConditions",
                "serviceOfferingName": "gx：serviceOfferingName",
                "serviceOfferingDescription": "gx：serviceOfferingDescription",
                "providedBy": "gx：providedBy",
                "aggregationOf": "gx：aggregationOf",
                "aggregationOfId": "gx：id",
                "policy": "gx：policy",
                "serviceOfferingTermsAndConditions": "gx：termsAndConditions",
                "url": "gx：URL",
                "hash": "gx：hash",
                "dataAccountExport": "gx：dataAccountExport",
                "requestType": "gx：请求类型",
                "accessType": "gx：访问类型",
                "formatType": "gx：formatType",
                "proof": "证明",
                "created": "已创建",
                "proofPurpose": "proofPurpose",
                "verificationMethod": "verificationMethod",
                "jws": "jws",
                "status": "状态",
                "primaryButton": "下载",
                "secondaryButton": "取消",
                "resourceName": "gx：name",
                "resourceDescription": "gx：description",
                "resourceCopyrightOwnedBy": "gx：copyrightOwnedBy",
                "resourceExposedThrough": "gx：exposedThrough",
                "resourceProducedBy": "gx：producedBy",
                "resourcePolicy": "gx：policy",
                "resourceLicense": "gx：license",
                "resourceContainsPII": "gx：containsPII",
                "resourceMaintainedBy": "gx：maintainedBy",
                "resourceOwnedBy": "gx：ownedBy",
                "resourceManufacturedBy": "gx：manufacturedBy",
                "resourceCountryCode": "国家/地区代码",
                "resourceLocality": "位置",
                "resourcePostalCode": "邮政编码",
                "resourceStreetAddress": "街道地址",
                "legalPersonRegistrationNumber": "gx：lagelRegistrationNumber"
            },
            "notificationText": "抱歉,我们未能找到符合您搜索条件的结果。请优化您的搜索条件后再试。",
            "bulkUpload": {
                "title": "验证您的合作伙伴",
                "helpText": "通过填写提供的模板,一次性验证您的业务合作伙伴",
                "uploadFileTitle": "上传文件",
                "requestCredentials": "请求凭证",
                "uploadFormHelpHeading": "要验证多家公司,请执行以下操作: ",
                "uploadFormHelpText1": "从下面的链接下载模板文件",
                "uploadFormHelpText2": "填写提供的文件,填写您的业务合作伙伴信息",
                "uploadFormHelpText3": "将文件拖放到下面的上传区域",
                "downloadTemplateBtn": "下载模板",
                "partnerValidationHelpText": "如果您想了解更多关于合作伙伴验证的信息,请",
                "partnerValidationHelpLink": "点击这里",
                "uploadFile": {
                    "uploadFileHeading": "选择要上传的CSV文件"
                },
                "vcProcessingTitle": "记录处理",
                "bulkVcContinueBtn": "继续",
                "issuingProgressMessage": "凭证签发进行中...",
                "doNotCloseWarning": "处理完成前请勿关闭表单",
                "bulkVcDownloadReportBtn": "下载报告",
                "successMessage": "成功完成！",
                "failedErrorMessage": "{result} 条记录存在错误",
                "processAbortTitle": "处理中断",
                "processAbortDescription": "您确定要停止处理吗？",
                "stopProcessingBtn": "停止处理"
            },
            "validation": {
                "vatId": {
                    "field": "请输入有效的增值税号码。",
                    "AT": "提示: 应以 'ATU' 开头,后跟8位数字。",
                    "BE": "提示: 应以 'BE' 开头,后跟10位数字。",
                    "BG": "提示: 应以 'BG' 开头,后跟9或10位数字。",
                    "CY": "提示: 应以 'CY' 开头,后跟8位数字和1个字母。",
                    "CZ": "提示: 应以 'CZ' 开头,后跟8至10位数字。",
                    "DE": "提示: 应以 'DE' 开头,后跟9位数字。",
                    "DK": "提示: 应以 'DK' 开头,后跟8位数字。",
                    "EE": "提示: 应以 'EE' 开头,后跟9位数字。",
                    "EL": "提示: 应以 'EL' 开头,后跟9位数字。",
                    "ES": "提示: 应以 'ES' 开头,后跟字母和数字的组合。",
                    "FI": "提示: 应以 'FI' 开头,后跟8位数字。",
                    "FR": "提示: 应以 'FR' 开头,后跟2个字母和9位数字。",
                    "HR": "提示: 应以 'HR' 开头,后跟11位数字。",
                    "HU": "提示: 应以 'HU' 开头,后跟8位数字。",
                    "IE": "提示: 应以 'IE' 开头,后跟复杂的数字和字母组合。",
                    "IT": "提示: 应以 'IT' 开头,后跟11位数字。",
                    "LT": "提示: 应以 'LT' 开头,后跟9至12位数字。",
                    "LU": "提示: 应以 'LU' 开头,后跟8位数字。",
                    "LV": "提示: 应以 'LV' 开头,后跟11位数字。",
                    "MT": "提示: 应以 'MT' 开头,后跟8位数字。",
                    "NL": "提示: 应以 'NL' 开头,后跟9位数字,加上 'B' 和2位数字。",
                    "PL": "提示: 应以 'PL' 开头,后跟10位数字。",
                    "PT": "提示: 应以 'PT' 开头,后跟9位数字。",
                    "RO": "提示: 应以 'RO' 开头,后跟2至10位数字。",
                    "SE": "提示: 应以 'SE' 开头,后跟12位数字。",
                    "SI": "提示: 应以 'SI' 开头,后跟8位数字。",
                    "SK": "提示: 应以 'SK' 开头,后跟10位数字。",
                    "XI": "提示: 应以 'XI' 开头,后跟9位数字。"
                },
                "eori": "请输入有效的EORI。提示: 应以2个大写字母开头,后跟9至15位数字。",
                "lei": "请输入有效的LEI。提示: 应为20个字符,前18个为大写字母数字,最后2个为数字。",
                "did": "请输入有效的DID。必须以 'did:' 开头,后跟方法和用冒号分隔的段,只能使用字母、数字、'%'、'.'、'_' 和 '-'。",
                "hash": "请输入有效的SHA-256哈希。必须正好64个十六进制字符（0-9,A-F）。",
                "format_type": "请输入有效的格式类型。格式必须是一个单词,后跟 '/',然后是字母、数字、'-'、'+'、'.' 或 '_' 组成的字符串。"
            }
        },
        "serviceOfferingForm": {
            "generalInformationHeading": "一般信息",
            "labelSOName": "服务产品名称",
            "labelProvidedBy": "提供方",
            "labelSODescription": "服务产品描述",
            "hintSOName": "服务产品的人类可读名称",
            "hintProvidedBy": "DID 形式的可解析链接,指向提供服务的参与者自我描述",
            "hintSODescription": "使用 DSL 表示的策略列表（例如,Rego 或 ODRL、访问控制、限制、使用、保留等）",
            "resourcesHeading": "资源",
            "labelSOResources": "资源自我描述",
            "hintSOResources": "DID 形式的资源自描述的可解析链接,与服务相关,可以独立于服务而存在",
            "termsAndConditionsHeading": "条款与条件",
            "labelUrlSO": "网址",
            "labelHashSO": "哈希值",
            "termsAndConditionsTooltip": "适用于服务产品的条款和条件的可解析链接",
            "labelSOPolicy": "策略",
            "policyTooltip": "适用于服务产品的策略的可解析链接",
            "personalDEHeading": "个人数据导出",
            "personalDETooltip": "使服务的客户能够将个人和非个人数据从服务中导出。",
            "labelRequestTypeSO": "请求类型",
            "labelAccessTypeSO": "访问类型",
            "placeholderRequestTypeSO": "选择请求类型",
            "placeholderAccessTypeSO": "选择访问类型",
            "labelFormatTypeSO": "格式类型",
            "hintRequestTypeSO": "请求数据检索的方法: API、电子邮件、webform、unregisteredLetter、registeredLetter、supportCenter",
            "hintAccessTypeSO": "数据类型支持: 数字、物理",
            "hintFormatTypeSO": "定义的媒体类型（MIME 类型）",
            "consentTC1": "我特此同意并确认上述所有输入的数据均准确无误",
            "consentTC2": "我特此同意并授权 T-Systems 处理我的数据（包括任何个人敏感数据）",
            "consentTC3": "我特此同意",
            "gaiaXTermsText": "Gaia-X 的条款和条件",
            "requestTypesList": {
                "api": "API",
                "email": "电子邮件",
                "webform": "网络表单",
                "unregisteredLetter": "未注册的信件",
                "registeredLetter": "挂号信",
                "supportCenter": "支持中心"
            },
            "requestTypesError": "请求类型为必填项。",
            "accessTypesList": {
                "digital": "数字",
                "physical": "物理"
            },
            "accessTypesError": "需要访问类型。",
            "helpSOName": "请输入您的服务的人类可读名称",
            "helpProvidedBy": "提供服务的参与者的去中心化标识符",
            "helpSOResources": "通过此服务公开的资源的去中心化标识符",
            "helpUrlSO": "请输入您的条款和条件文档的链接（例如 https://service.com/terms)",
            "helpHashSO": "请输入您的条款和条件文档的 sha256 哈希值",
            "helpPolicySO": "请输入使用 DSL 表示的策略（例如 Rego 或 ODRL)",
            "helpRequestTypeSO": "请从下拉列表中选择请求类型",
            "helpAccessTypeSO": "请从下拉列表中选择访问权限类型",
            "helpFormatTypeSO": "请输入 MIME 类型（例如 application/json)"
        },
        "resourceForm": {
            "generalInformationHeading": "一般信息",
            "generalInformationSubHeading": "请输入您的资源一般信息",
            "labelResourceType": "资源类型",
            "placeholderResourceType": "选择资源类型",
            "errorResourceType": "资源类型为必填项",
            "labelResourceName": "资源名称",
            "labelResourceDescription": "资源描述",
            "hintResourceType": "所描述的资源的类型",
            "hintResourceName": "资源的人类可读名称",
            "hintResourceDescription": "资源的人类可读描述",
            "physicalResource": "物理资源",
            "softwareResource": "软件资源",
            "dataResource": "数据资源",
            "additionalInformationHeading": "其他信息",
            "additionalInformationSubHeading": "请输入您的资源附加信息",
            "labelMaintainedBy": "维护者",
            "hintMaintainedBy": "参与者的 Gaia-X 凭证的可解析链接,该参与者将资源保持在运行状态,从而可以物理访问它",
            "labelOwnedBy": "所有者",
            "hintOwnedBy": "指向拥有资源的参与者的 Gaia-X 凭证的可解析链接",
            "labelManufacturedBy": "制造者",
            "hintManufacturedBy": "可解析的链接到制造资源的参与者的 Gaia-X 凭证",
            "labelCountry": "国家/地区",
            "hintCountry": "资源所在的国家/地区",
            "labelCity": "城市",
            "hintCity": "资源所在的城市/城镇",
            "labelPostCode": "邮政编码",
            "hintPostCode": "资源所在的邮政编码",
            "labelStreet": "街道",
            "hintStreet": "资源所在的街道和门牌号",
            "labelCopyrightOwnerBy": "版权所有者依据",
            "hintCopyrightOwnerBy": "版权所有者是有权利用资源的个人或组织。版权所有者不一定是指资源的作者,该作者是自然人,可能与版权所有者不同。以自由文本或版权所有者的 Gaia-X 凭证的可解析链接表示。",
            "labelLicense": "许可证",
            "hintLicense": "许可证文档的 URL 或来自的许可证之一",
            "labelPolicy": "策略",
            "hintPolicy": "使用 DSL（例如 Rego 或 ODRL）表示的策略列表（访问控制、限制、使用、保留等）。如果省略策略约束,则假定允许所有参与者使用",
            "labelProducedBy": "生产者",
            "hintProducedBy": "合法启用数据使用的参与者的 Gaia-X 凭证的可解析链接。",
            "labelExposedThrough": "暴露方式",
            "hintExposedThrough": "指向公开数据资源的数据交换组件的可解析链接",
            "locationHeading": "位置详细信息",
            "locationSubHeading": "请输入您的资源位置详细信息",
            "licenseTooltipText": "SPDX 许可证列表",
            "licenseTooltipLink": "https://spdx.org/licenses/",
            "consentPII": "我特此确认数据资源不包含个人身份信息 （PII）。"
        },
        "verifyLanding": {
            "heading": "欢迎使用",
            "subHeading": "增加对数字生态系统的信任度！",
            "description1": "您想要验证和确认您的业务合作伙伴,还是想要出示自己的身份证明和验证？然后您应该请求您的第一个可验证凭证 - 我们的",
            "description2": "可验证凭证可以包含与您的物理身份相同的信息（例如身份证、驾驶执照）甚至更多属性。添加数字签名等技术后,可验证凭证比物理凭证更易被篡改且更值得信赖",
            "description3": "T-Systems 是首批 Gaia-X 数字清算所节点之一,并根据 Gaia-X 信任框架规范发布您的数字证明。此外,我们还添加了来自 Telekom Security 合作伙伴的符合 eIDAS 的数字签名",
            "requestButton": "请求 Digital.ID",
            "digitalID": "Digital.ID 产品。",
            "consultation": {
                "heading": "请求您的凭据或验证您的合作伙伴",
                "placeholder": "以前有使用可验证凭证的经验吗？ 对你的第一个证书感兴趣吗"
            },
            "sendAnotherRequest": "发送另一个请求",
            "lastRequest": "您的最新请求已发送"
        },
        "getInsights": {
            "tab1": "报告",
            "tab2": "API 使用限制",
            "tab3": "技术集成",
            "monthsByOptions": {
                "option1": "3 个月",
                "option2": "6 个月",
                "option3": "1 个月"
            },
            "table": {
                "heading2": "参考期",
                "heading3": "创建时间",
                "heading4": "作"
            },
            "successDownload": "已成功下载报告",
            "errorDownload": "您的 {filename} 文件下载因错误而中止,请重试。",
            "apiUsageLimit": {
                "requestNameTitle": "请求名称",
                "dailyTitle": "每日 API 请求数",
                "monthlyTitle": "每月 API 请求数",
                "limitexhaustedWarning": "剩余请求少于 10%",
                "limitExtentionHeading": "请求扩展限制",
                "limitExtentionPlaceholder": "对延长您的 API 使用限制感兴趣？",
                "supportBtn": "支持",
                "limitExtentionText": "即将达到限制？与我们联系,让我们一起解决吧！"
            },
            "addIntegration": "添加集成",
            "integrationData": {
                "clientId": "客户端 ID",
                "createdAt": "创建时间",
                "actions": "作"
            }
        },
        "addIntegration": {
            "generalInformationHeading": "一般信息",
            "addAnIntegration": "添加集成",
            "clientId": "客户端 ID",
            "clientName": "客户端名称",
            "clientSecret": "客户端密钥",
            "tokenUrl": "令牌 URL",
            "pcCallbackUrl": "参与者凭证回调 URL",
            "soCallbackUrl": "服务产品凭证回调 URL",
            "digitalIdAuthenticateInfo1": "Digital.ID 验证将如何对您的系统进行身份验证？",
            "digitalIdAuthenticateInfo2": "Digital.ID Compliance 将如何对您的系统进行身份验证？",
            "seeResults": "我们应该将结果发送到哪里？",
            "requestSuccess": "添加成功",
            "callbackSuccess": "回调添加成功",
            "step1Name": "验证身份验证详细信息",
            "step2Name": "合规性身份验证详细信息",
            "step3Name": "回调信息",
            "deleteSuccess": "删除成功",
            "downloadSuccess": "下载成功",
            "editCallbackHeading": "添加回传",
            "deleteModal": {
                "heading": "删除确认",
                "deleteContent": "您确定要删除客户端吗",
                "deleteNote": "删除客户端后,它将从列表中消失,无法再使用。要恢复它,你必须从头开始重新创建"
            }
        },
        "mySignatures": {
            "certificatesOrdering": {
                "heading": "欢迎使用 我的签名",
                "subHeading": "是否要申请允许您签署索赔的数字证书？",
                "description1": "使用我们的 Digital.ID 产品,您可以轻松申请您的第一个证书,并开始享受安全数字协作的好处。",
                "description2": "可验证凭证可以包含与您的物理标识符相同的信息,例如身份证和驾驶执照,甚至更多。在发行过程中,您将使用您自己的可信赖证书签署您的信息,以确认您的信息的准确性。",
                "description3": "您可以安全地请求和维护您的数字证书,以满足您的所有签名需求。我们与经过认证的数字证书提供商独家合作,确保您的数字证书既安全又值得信赖。",
                "requestButton": "请求证书",
                "consultation": {
                    "heading": "请求证书",
                    "placeholder": "请输入有关您的请求的必要详细信息"
                }
            },
            "certificateOverview": {
                "heading": "我的签名",
                "requestCertificateCTA": "请求证书",
                "placeholderCertificateType": "证书类型",
                "placeholderCertificateStatus": "证书状态",
                "EVSSL": "EV SSL",
                "EIDAS": "EIDAS",
                "headingEVSSL": "EV SSL 证书",
                "headingEIDAS": "EIDAS 证书",
                "certificateDetailsHeading": "证书详细信息",
                "certificateName": "名称",
                "certificateId": "ID",
                "certificateType": "类型",
                "provider": "提供商",
                "organizationId": "组织 ID",
                "UUID": "UUID",
                "certificate": "证书",
                "createdAt": "创建时间",
                "updatedAt": "更新时间",
                "certificateExpiry": "过期时间",
                "certificateVerificationMethod": "验证方法",
                "certificateDidJson": "DID JSON",
                "status": "状态",
                "certificateDownloadSuccess": "证书下载成功",
                "deleteCertificate": {
                    "heading": "删除确认",
                    "question": "您确定要删除证书吗",
                    "deleteSuccess": "已成功删除证书"
                }
            }
        }
    },
    "build": {
        "ownedDataspaces": "我的数据空间",
        "checkConsent": "我同意将我的联系数据提供给 T-Systems 销售团队并与之联系。",
        "welcomeOwnedDataspace": "欢迎来到'拥有的数据空间'",
        "resendInvitation": "发送",
        "resendInvitationInfo": "您可以在上次邀请邮件发送 24 小时后立即发送通知。",
        "requestSuccessTitle": "请求成功！",
        "requestSuccessBody": "您的请求已发送...您将在几个工作日内收到答复",
        "requestAuthorisation": "如果您希望增加必要的授权,请联系 dih.support{'@'}telekom.com。",
        "inviteParticipant": {
            "buttonLabel": "邀请参与者",
            "successNotificationTitle": "邀请成功！",
            "successNotificationContent": "您的邀请已成功发送",
            "alreadySentNotificationTitle": "已向此电子邮件地址发送邀请。",
            "alreadySentNotificationContent": "请等待 24 小时,然后再次发送邀请。",
            "resendInviteNotificationTitle": "重新邀请成功！",
            "resendInviteNotificationContent": "您的重新邀请已成功发送",
            "modal": {
                "title": "邀请参与者",
                "informationTitle": "信息",
                "informationText": "受邀组织可以与其他参与者交换数据,并在数据空间中发布新的数据资产。此外,组织可以使用属于您数据空间的应用程序和服务。有关更多信息,请查看以下内容:",
                "formTitle": "请输入新参与者的详细信息",
                "organizationName": "组织名称",
                "proceed": "继续",
                "cancel": "取消"
            },
            "withdrawInvitation": {
                "modal": {
                    "title": "撤回邀请",
                    "informationText": "您确定要撤销邀请吗？",
                    "successNotificationTitle": "提现成功",
                    "successNotificationBody": "已成功撤回邀请",
                    "withdraw": "提现"
                }
            },
            "resendInvitation": {
                "modal": {
                  "title": "重新发送邀请",
                  "informationText": "您确定要重新发送此邀请吗？"
                }
            }
        },
        "editParticipant": {
            "modal": {
                "title": "编辑参与者",
                "cancel": "取消",
                "save": "保存",
                "roleSection": {
                    "name": "角色",
                    "helpText": "我应该选择哪个角色？",
                    "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
                    "ownerLabel": "数据空间所有者",
                    "ownerTooltip": "可以管理参与者和应用程序的数据空间所有者",
                    "operatorLabel": "数据空间运算符",
                    "operatorTooltip": "可以管理 Operator Toolkit 和板载应用程序的参与者",
                    "operatorCheckboxTooltip": "您是数据空间的所有者。因此,您无法取消选择 Operator。",
                    "appProviderLabel": "应用程序提供商",
                    "appProviderTooltip": "可以将应用程序载入数据空间的数据空间参与者",
                    "participantLabel": "数据空间参与者",
                    "participantTooltip": "可以充当数据提供者和数据使用者的参与者",
                    "participantCheckboxTooltip": "无法禁用数据空间参与者。这是用户在数据空间中的默认状态。"
                },
                "visibilitySection": {
                    "name": "可见性",
                    "helpText": "我应该选择哪个公开范围？",
                    "helpUrl": "https://docs.dih.telekom.com/en/space/living-lab/manage-your-livinglab",
                    "anonymousLabel": "匿名",
                    "anonymousLabelTitle": "匿名参与者",
                    "anonymousTooltip": "对其他参与者隐藏且无法查看其他参与者的参与者"
                }
            },
            "updateSuccessfulTitle": "更新成功！",
            "updateSuccessfulBody": "已采用新的角色和可见性"
        },
        "applicationManagement": {
            "buttonLabel": "注册应用程序",
            "registerForm": {
                "pageTitle": "应用程序注册",
                "step1Name": "应用程序详细信息",
                "step2Name": "应用程序访问",
                "displayName": "显示名称",
                "providedBy": "提供商",
                "providedByPlaceholder": "组织名称",
                "description": "描述",
                "descriptionPlaceholder": "描述文本",
                "link": "链接",
                "linkPlaceholder": "https://www.application-link-example.org/",
                "appImage": "申请图片 (JPG 或 PNG,限制为 2 MB)*",
                "appImagePlaceholder": "将文件拖放到此处，或单击以选择文件",
                "appImagePlaceholder2": "或浏览计算机上的文",
                "category": "类别",
                "categoryPlaceholder": "输入类别",
                "usecases": "使用场景",
                "usecasesPlaceholder": "输入使用场景",
                "agreementCheckboxLabel": "我特此同意,我对我正在注册的应用程序负全部责任,并且它不是任何类型的恶意软件。此外,我已确保没有违反许可证。我了解我对应用程序的访问管理负全部责任,T-Systems International GmbH 在这方面不承担任何责任。T-System International GmbH 不对该应用程序及其可能的任何可能后果负责或承担任何可能的后果。"
            },
            "deleteApplication": {
                "modal": {
                    "title": "删除应用程序",
                    "informationText1": "请再次确认您确定要从数据空间中删除此应用程序链接。此应用程序将不适用于您的数据空间中的任何参与者。",
                    "informationText2": "请注意,实际应用程序将不受影响！",
                    "successNotificationTitle": "删除成功",
                    "successNotificationBody": "已成功删除应用程序",
                    "cancel": "取消",
                    "delete": "删除"
                }
            },
            "editForm": {
                "pageTitle": "编辑应用程序",
                "step1Name": "应用程序详细信息",
                "step2Name": "应用程序访问",
                "displayName": "显示名称",
                "providedBy": "提供商",
                "providedByPlaceholder": "组织名称",
                "description": "描述",
                "descriptionPlaceholder": "描述文本",
                "link": "链接",
                "successNotificationTitle": "编辑成功",
                "successNotificationBody": "应用程序编辑成功",
                "linkPlaceholder": "https://www.application-link-example.org/",
                "currentImage": "当前图片",
                "agreementCheckboxLabel": "我特此同意,我对我正在注册的应用程序负全部责任,并且它不是任何类型的恶意软件。此外,我已确保没有违反许可证。我了解我对应用程序的访问管理负全部责任,T-Systems International GmbH 在这方面不承担任何责任。T-System International GmbH 不对该应用程序及其任何可能的方式可能产生的后果负责或承担任何可能的后果。",
                "cancel": "取消",
                "save": "保存更改"
            }
        },
        "networkManagement": {
            "buttonLabel": "添加新的 IP 地址",
            "pageTitle": "网络管理",
            "ipAddressLabel": "IP 地址",
            "lastUpdatedOn": "最后更新于",
            "ipHint": "IP地址更新请求已收到，将很快处理。",
            "ipRemove": "您确定要删除此IP地址吗？",
            "ipRequired": "需要提供IP地址",
            "ipInvalid": "请输入有效的IP地址",
            "ipEnter": "请输入您要加入白名单以访问数据空间的IP地址。"
        },
        "invite": {
            "inviteLabel": "邀请参与者"
        },
        "allocateConnectors": {
            "pageTitle": "连接器分配",
            "allocateConnectorLabel": "分配连接器",
            "topUpConnectorsButtonLabel": "充值连接器",
            "topUpConnectorTitle": "您的请求已成功提交。",
            "topUpConnectorBody": "我们的支持团队将尽快与您联系,讨论更多细节。",
            "generalTooltipMessage": "请联系 DIH 支持 (dih.support{'@'}telekom.com) 为现有参与者分配新连接器或邀请新参与者加入数据空间",
            "tooltipMessage": "根据合同,您已经用完了可用的最大连接器数量。如果您想增加配额或修改合同,请联系 dih.support{'@'}telekom.com",
            "allocationForm": {
                "step1Name": "组织",
                "step2Name": "连接器",
                "organizationNameDescription": "选择应为其分配新连接器的公司",
                "organizationNameLabel": "组织名称",
                "organizationPlaceholder": "选择组织",
                "inviteParticipantDescription": "或者点击邀请参与者按钮,邀请新公司在数据空间上合作",
                "inviteParticipantButton": "邀请参与者",
                "numberOfConnectorsDescription": "选择连接数",
                "numberOfConnectorsLabel": "连接器数量",
                "numberOfConnectorsPlaceholder": "计数",
                "progressBarDescription": "连接器配额",
                "progressBarInfo": "{numberOfConnectors} 连接器可用",
                "allocateButtonLabel": "分配",
                "cancelButtonLabel": "取消",
                "noConnectorRemaining": "所有连接器都已使用。请点击\"充值连接器 与我们的团队讨论连接器的扩展事宜。"
            },
            "successRequestTest": "请求成功",
            "successRequestBody": "已成功启动连接器分配",
            "decisionModal": {
                "title": "您已被邀请加入 {dataspaceName}",
                "accept": "接受",
                "decline": "拒绝",
                "acceptSuccessNotificationTitle": "接受成功！",
                "acceptSuccessNotificationBody": "您已成功接受加入 {dataspaceName} 的邀请。",
                "declineSuccessNotificationTitle": "邀请被拒绝！",
                "declineSuccessNotificationBody": "您已拒绝加入 {dataspaceName} 的邀请。"
            }
        },
        "request": {
            "requestTitle": "在数据共享旅程中迈出下一步,创建您自己的数据空间！",
            "requestDescription1": "您不仅想共享自己的数据,还希望让您的业务合作伙伴能够相互共享数据？然后,您应该考虑创建一个数据空间,这是一个用于共享数据或将数据货币化的可信社区。",
            "requestDescription2": "T-Systems 将在我们可靠的基础设施上设置和运营您的数据空间。",
            "requestDescription3": "我们还为您的首次数据空间体验 ('LivingLab') 提供低阈值测试设置。",
            "request": "请求",
            "sendAnotherRequest": "发送另一个请求",
            "lastRequest": "您的上次请求已发送于",
            "back": "返回",
            "sendRequest": "发送请求",
            "requestedTextPlaceholder": "您在寻找特定或一般的咨询吗？以前有过数据空间的经验吗？对测试设置感兴趣",
            "visitorAnalyticsPro": {
                "title": "通过 Motion Data 请求 Visitor Analytics PRO",
                "placeholder": "您是否正在寻找一些特定的产品或一般咨询来满足您的数据需求？以前有使用 Motion Data 产品的经验吗？对演示感兴趣吗"
            }
        },
        "create": {
            "createTitle": "创建您自己的数据空间",
            "createDesc": "您可以向我们的专家团队发送请求,我们会尽快回复您。",
            "tellUsMore": "您能告诉我们更多关于您的请求的信息吗？"
        },
        "details": {
            "approve": "批准",
            "decline": "拒绝",
            "approval": "审批",
            "requesterNotes": "请求者备注",
            "adminNotes": "管理员备注",
            "decisionTakenTooltip": "接受或拒绝已经发生。目前正在准备提供连接器。完成后,您将立即收到通知。",
            "decisionInputPlaceholder": "批准或拒绝的说明...",
            "activeParticipants": "活跃参与者",
            "incomingRequests": "传入请求",
            "invitations": "邀请",
            "manage": "管理",
            "enter": "进入",
            "providedBy": "提供商",
            "registered": "已注册",
            "operatorToolkit": "作员工具包",
            "noOperatorToolkit": "操作工具集中没有启用任何工具",
            "errorOperatorToolkit": "获取操作工具集详情时出错",
            "dataspaceDetails": "数据空间详细信息",
            "contactDetails": "联系方式",
            "visibilityTitle": "在浏览数据空间列表中隐藏您的数据空间",
            "manageParticipants": "管理参与者",
            "applicationManagement": "应用管理",
            "networkManagement": "网络管理",
            "noApplications": {
                "title": "您还没有申请",
                "actionButtonText": "注册应用程序"
            },
            "contactUs": "如果您想更新任何信息,请直接联系我们",
            "noData": "您还没有任何数据",
            "basic": "基本",
            "companyName": "公司名称",
            "participantName": "参与者姓名",
            "participationMode": "参与模式",
            "connectorName": "连接器名称",
            "connectorVariant": "连接器变体",
            "contact": "联系人",
            "address": "地址",
            "street": "街道",
            "number": "数字",
            "postalCode": "邮政编码",
            "city": "城市",
            "country": "国家",
            "phoneNo": "电话号码",
            "contactPerson": "联系人",
            "email": "电子邮件",
            "dateOfJoining": "加入日期",
            "dateOfInvitation": "日期",
            "operator": "运算符",
            "dateOfRequest": "请求日期",
            "url": "URL",
            "status": "状态",
            "bpn": "业务合作伙伴编号",
            "name": "名称",
            "description": "描述",
            "website": "网站",
            "dataspaceId": "数据空间 ID",
            "password": "密码",
            "digitalId": "此数据空间已启用 Digital.ID",
            "disableDigitalId": "未为此数据空间启用 Digital.ID",
            "company": "公司 |公司",
            "connector": "连接器 |连接器",
            "application": "应用程序 |应用",
            "dataoffer": "数据报价 |数据提供",
            "visibility": "您的数据空间现在是 {access}",
            "discoverable": "可发现",
            "private": "私有",
            "statusTooltip": {
                "invited": "已发送加入数据空间的邀请",
                "inprogress": "被邀请者已提交入职表单",
                "expired": "由于 14 天处于非活动状态，邀请已过期",
                "withdrawn": "邀请已被撤回",
                "rejected": "载入请求已被拒绝。请联系 dih.support{'@'}telekom.com 了解更多详情",
                "active": "参与者已成功加入",
                "failed": "失败"
            },
            "deleteParticipant": {
                "modal": {
                    "title": "删除参与者",
                    "informationText": "确认后,属于参与者的连接器将被取消部署。此作无法撤消。",
                    "successNotificationTitle": "请求删除",
                    "successNotificationBody": "请求删除参与者",
                    "cancel": "取消",
                    "delete": "删除"
                }
            },
            "services": {
                "applicationOrchestration": "应用程序编排",
                "applicationOrchestrationDesc": "部署和管理您的业务应用程序",
                "identityAccessManagement": "身份与访问管理",
                "identityAccessManagementDesc": "管理您的用户及其对资源的访问",
                "continuousDelivery": "持续交付",
                "continuousDeliveryDesc": "采用部署和运营最佳实践",
                "secretCredentialManagement": "密钥和凭证管理",
                "secretCredentialManagementDesc": "保护、存储和控制对令牌、密码和证书的访问",
                "monitoring": "监控",
                "monitoringDesc": "查询、可视化、提醒并了解您的指标和 KPI",
                "connectorTest": "连接器运行状况检查",
                "connectorTestDesc": "为连接器运行运行状况检查的服务。",
                "catenaXSandbox": "Catena-X 沙盒",
                "catenaXSandboxDesc": "在 LivingLab 中启动 Catena-X 沙箱,以在 Catena-X 环境中开发和测试新的业务应用程序。"
            }
        },
        "connectorHealthCheck": {
            "title": "连接器运行状况检查",
            "viewResults": "查看结果",
            "close": "关闭",
            "description": "选择要对其执行运行状况检查的一个或多个连接器。标准数据空间作将不受运行状况检查的影响。",
            "connectors": "连接器",
            "placeholder": "选择连接器",
            "searchInputLabel": "搜索连接器...",
            "banner": "执行运行状况检查可能需要几分钟时间。一旦结果可用,您将立即收到通知。",
            "action": "启动",
            "history": {
                "connectorName": "连接器名称",
                "initiated": "已启动",
                "completed": "已完成",
                "result": "结果",
                "successMessage": "{connectorName} 正在按预期工作",
                "unsuccessfulMessage": "{connectorName} 未按预期工作。请联系"
            },
            "successNotificationTitle": "连接器运行状况检查已启动。",
            "successNotificationContent": "当结果可用时,您将收到通知。",
            "noTest": "您还没有测试",
            "initiateTest": "发起测试"
        },
        "specifications": {
            "table": {
                "attribute": "属性",
                "value": "值",
                "cloudProvider": "云提供商",
                "contractStart": "合约开始",
                "contractDuration": "合同持续时间",
                "cpu": "CPU",
                "ram": "RAM",
                "storage": "存储",
                "maximumConnectorsBookable": "可预订的最大连接数",
                "subscribedConnectors": "已订阅的连接器"
            },
            "dataspaceSpecifications": "数据空间规格",
            "livinglabCore": "LivingLab 核心",
            "livinglabAppLayer": "LivingLab 应用程序层"
        },
        "connectorManagement": {
            "connectorManagement": "连接器管理",
            "connectorName": "连接器名称",
            "connectorType": "连接器类型",
            "targetParticipant": "目标参与方",
            "connectorOwner": "连接器所有者",
            "url": "网址",
            "status": "状态",
            "connectorUrl": "连接器 URL",
            "connectorUiUrl": "连接器 UI URL",
            "connectorRegistration": "连接器注册",
            "connectorDeployment": "连接器部署",
            "technicalUser": "技术用户",
            "selfDescRegistration": "自述注册",
            "connectorDeleteTitle": "你确定要删除连接器吗？",
            "connectorDeleteDescription": "请注意：此作不会删除或停止在基础架构中运行的实际连接器实例。一旦删除，此连接器将不再出现在 DIH 门户中，也不会用于此数据空间内的数据交易，直到重新注册。",
            "deleteSuccessMessage": "连接器已成功删除",
            "saveSuccessMessage": "连接器详细信息已成功更新",
            "registerConnector": "注册自己的连接器",
            "howToConfigure": "如何配置您的连接器",
            "howToDescription": "以下信息提供了注册和后续部署外部连接器所需的配置值。这些设置使您的连接器能够正确认证并与Dataspace服务交互。",
            "howToDescription1": "部署前，你的连接器必须在数据空间注册。该流程涵盖了注册步骤。你在接下来步骤中输入的URL字段可以稍后编辑，所以即使有些端点尚未最终确定，你也可以继续。",
            "supportedEDCVersions": "支持的 EDC 版本：",
            "howToInfo": {
            "info1": "iatp.sts.oauth.client.id：该连接器的技术用户客户端ID。",
            "info2": "iatp.sts.oauth.client.secret：该连接器的技术用户秘密。",
            "info3": "上述两个数值将在连接器注册完成后公布。完成注册流程后，你可以部署连接器。"
            },
            "connectorRegistationTitle": "连接器注册详情",
            "location": "地点*",
            "locationError": "需要位置",
            "connectorRegistrationProgress": "连接器注册进行中",
            "connectorCatalogEndpoint": "连接器目录端点*",
            "connectorUIEndpoint": "连接器 UI 端点（可选）",
            "connectorRegistrationInfo": "可以在数据空间的连接器管理部分检查连接器注册状态。",
            "viewConfiguration": "视图配置",
            "name": "名字",
            "value": "价值",
            "stepToDeployConnector": "部署连接器的步骤：",
            "deploymentGuide": "连接器部署指南",
            "clientIdDummyValue": "连接器技术用户的客户端ID",
            "secreteDummyValue": "连接器技术用户的秘密",
            "failedConnectorDeploymentTooltip": "连接器目前不可用。部署待定。"
        }
    },
    "profile": {
        "profile": "个人资料",
        "userProfile": "用户资料",
        "personalInfo": "个人信息",
        "personalDetails": "个人详细信息与设置",
        "changeDetailsMessage": "如果您希望更改任何信息，请联系",
        "changeDetailsLinkText": "支持团队",
        "memberships": "会员身份",
        "security": "安全",
        "setUp2FA": "设置双重身份验证",
        "accountInformation": "账户信息",
        "deleteAccount": "删除用户账户",
        "deleteAccountDescription": "执行此操作后，与您个人账户相关的所有数据和数据文件将被删除。",
        "accountSecurity": "账户安全",
        "yourInfomration": "您的信息",
        "fullName": "全名",
        "contact": "联系方式",
        "language": "语言",
        "changePassword": "更改密码",
        "please": "请",
        "contactSupport": "联系支持",
        "toDownload": "下载此信息",
        "toDelete": "删除您的个人资料",
        "roles": "角色",
        "memberSince": "会员时间",
        "orgLegalName": "组织法定名称",
        "bpnNumber": "商业伙伴编号（BPN）",
        "commRegNumber": "商业注册编号",
        "vatIdNumber": "增值税编号",
        "hqAddress": "总部地址",
        "legalIdentifier": "法律标识符",
        "additionalAttributes": "附加属性",
        "languageSwitcherMessage": "本页面部分内容由机器或人工智能翻译。觉得可以改进？请通过 dih.support{'@'}telekom.com 告诉我们。"
    },
    "plansBenefits": {
        "communicationIntegrity": "通信完整性",
        "protectedConnection": "受保护的连接",
        "mutualAuth": "双向认证",
        "stateArtOfCrypto": "最先进的加密技术",
        "remoteAttestation": "远程认证",
        "platforInt": "平台完整性",
        "configureAndApp": "配置与应用集成",
        "dataUsageControl": "数据使用控制",
        "definitionOfUsagePolicy": "使用策略定义",
        "from": "从",
        "month": "月",
        "connect": "连接"
    },
    "cookieSettings": {
        "collapsedTitle": "隐私设置",
        "collapsedText": "本网站使用 Cookie 和类似技术。这些是存储在您计算机上的小型文本文件。点击“{0}”，即表示您同意数据处理、在多个网站和合作伙伴之间创建个人用户档案以及将您的数据传输给第三方（其中一些在欧盟以外的国家处理您的数据，依据 GDPR 第 49 条）。详情请参见第 2 节的 {1}。这些数据用于分析、重定向以及在 Telekom 网站和第三方网站上播放个性化内容和广告。更多信息，包括第三方提供商的数据处理信息和撤销的可能性，请查看设置和我们的隐私信息。在此，您可以{2}仅使用必要工具。",
        "extendedTitle": "隐私设置",
        "extendedText": "为了为您提供最佳的网站体验，我们使用 Cookie。这些包括网站运营和优化所需的 Cookie，以及基于您在线使用行为的文本或视频聊天和广告服务。例如，这使我们能够检测您是否从同一设备重复访问我们的网站。我们希望您能选择允许哪些 Cookie：",
        "onlyRequired": "仅必要项",
        "policyLinkHref": "https://dih.telekom.com/en/privacy-policy",
        "policyLinkCookieHref": "https://dih.telekom.com/en/privacy-policy",
        "policyLinkTextShort": "隐私信息",
        "policyLinkText": "隐私信息",
        "rejectLinkText": "继续",
        "acceptButton": "接受所有",
        "saveButton": "保存设置",
        "settingsButton": "更改设置",
        "showMore": "显示更多",
        "showLess": "显示更少",
        "categoryTitleEssential": "必要的 Cookie",
        "categoryTitleAnalytics": "分析 Cookie",
        "categoryTitleMarketing": "营销 Cookie",
        "categoryTitleThirdParty": "其他公司提供的服务（独立的第三方提供商）",
        "categoryTextEssential": "这些 Cookie 是您浏览网站和使用主要功能所必需的。它们支持基本功能，例如在线商店的订单处理和对网站安全区域的访问。同时也用于对用户行为进行匿名分析，以便我们能不断开发和改进网站。",
        "categoryTextAnalytics": "这些 Cookie 帮助我们更好地了解用户行为。分析 Cookie 允许原始提供商或第三方提供商将使用和识别数据编译成假名使用档案。例如，我们使用分析 Cookie 来确定网页或服务的访问者数量，收集我们产品性能的统计数据，并根据匿名和假名信息分析用户行为和互动。这些信息无法追溯到个人。",
        "categoryTextMarketing": "这些 Cookie 和类似技术用于显示个性化且相关的营销内容。营销 Cookie 用于显示有趣的广告内容并衡量我们广告活动的效果。这不仅发生在 Telekom 网站上，也发生在其他广告合作伙伴的网站上（第三方）。这也称为重定向。其目的是创建假名内容或广告档案，在其他网站上投放相关广告，并得出查看广告和内容的目标群体的洞察。这些信息无法追溯到个人。即使禁用营销 Cookie，您看到的广告数量不会减少，但可能与您无关。",
        "categoryTextThirdParty": "Telekom 的网站包含指向第三方服务提供商的链接，这些服务提供商在其自身责任下提供服务。当您访问 Telekom 的网页时，Cookie 或类似技术会记录数据并将其发送给第三方，部分用于 Telekom 自身目的。关于第三方为其自身目的进一步处理数据的范围、目的和法律依据，请参阅该第三方的隐私信息。独立第三方提供商的信息可在隐私信息中找到。"
    },
    "consultation": {
        "createDescription": "您可以向我们的专家团队发送请求，我们将在几个工作日内回复您。",
        "tellUsMore": "请告诉我们更多关于您的请求的信息？",
        "checkConsent": "我同意将我的联系方式提供给 T-Systems 销售团队，并接受其联系。",
        "back": "返回",
        "sendRequest": "发送请求",
        "successMsgtitle": "请求成功！",
        "successMsgBody": "您的请求已发送……您将在几个工作日内收到回复"
    },
    "notifications": {
        "notifications": "通知",
        "inbox": "收件箱",
        "clearAll": "清除所有",
        "blankState": {
            "heading": "暂无通知",
            "description": "当您收到通知时，它们将显示在此处",
            "actionButtonText": "刷新"
        },
        "actionMessage": {
            "seeRequest": "查看请求",
            "here": "这里",
            "checkResult": "查看结果"
        },
        "goToMyAccount": "请在 {myAccountLink} 查看您的新角色信息。"
    },
    "statusTile": {
        "noMembership": {
            "title": "您尚未加入任何会员",
            "subTitle": "浏览数据空间以加入其中一个",
            "getConnected": "开始连接"
        }
    },
    "settings": {
        "organization": {
            "pageTitle": "我的组织",
            "orgDetails": "组织详情",
            "teamMembers": "团队成员",
            "groups": "团体",
            "groupsOverview": "集团概览",
            "technicalUsers": "技术用户",
            "singleSignOn": "单点登录",
            "mapGroupClaims": "地图组主张"
        },
        "teamMembers": {
            "title": "用户管理",
            "description": "此部分帮助您管理组织中的用户"
        },
        "groups": {
            "title": "集团管理",
            "description": "组代表你组织内的各部门。组内的用户始终是主组织的成员。",
            "createGroup": "创建组",
            "groupName": "集团名称",
            "groupDesc": "组别描述",
            "groupCreateNote": "成员可在创建后被分配到该组。只能添加现有的组织成员。",
            "membersTitle": "成员",
            "members": "成员",
            "createdBy": "创作者",
            "createdOn": "创作于",
            "contactPerson": "联系人",
            "actions": "行动",
            "groupMembers": "团体成员",
            "groupDetails": "集团详情",
            "groupMembersDescription": "将现有组织成员分配到该组",
            "disableAddMembers": "群组成员资格通过 SSO 声明进行管理。请使用您的身份提供商管理群组访问权限。",
            "addMembers": "添加成员",
            "fullName": "全名",
            "addedToGroup": "加入组别",
            "addMembersTo": "将成员添加到“{name}”",
            "addToGroup": "添加到组",
            "addMemberDescription": "从你的组织成员中选择。被选中的成员也将继续作为主组织成员。",
            "membersSelected": "成员已选定",
            "editSuccess": "组别详情已成功编辑",
            "addMemberSuccess": "已成功添加的选定用户加入群组",
            "duplicateGroupNameError": "同名的团体已经存在。请选择一个别的名字。"
        },
        "inviteUser": {
            "inviteUsers": "邀请用户",
            "newEmailAddress": "新团队成员的电子邮箱地址",
            "chooseRole": "选择角色",
            "whichRoleToSelect": "我应该选择哪个角色？",
            "roleNote": "所选角色将赋予所有被邀请的用户",
            "roleError": "请从可用选项中至少选择一个角色",
            "roleErrorShort": "请至少选择一个角色",
            "cancel": "取消",
            "sendInvite": "发送邀请",
            "fullName": "全名",
            "status": "状态",
            "role": "角色",
            "memberSince": "成员加入时间"
        },
        "inviteSuccess": {
            "title": "邀请摘要",
            "totalInvitation": "已发送 {count} 个邀请 | 已发送 {count} 个邀请",
            "description": "{count} 条邀请未发送，因为该电子邮件地址已存在于 Data Intelligence Hub 中 | {count} 条邀请未发送，因为这些电子邮件地址已存在于 Data Intelligence Hub 中",
            "actionContinue": "继续"
        },
        "roleChange": {
            "areYouSure": "您确定要进行这些角色更改吗？",
            "yeahSure": "是的，我确定"
        },
        "technicalUser": {
            "title": "技术用户凭证",
            "createdAt": "创建于",
            "clientId": "客户端ID",
            "clientSecret": "客户端秘密",
            "sendCredEmailBtn": "将凭证发送到我的邮箱",
            "sendCredEmailDescription": "包含您的凭证信息的邮件将发送到您的邮箱地址。请几分钟后查看您的收件箱。",
            "use": "使用 the",
            "clipboardText": "图标用于将客户端ID复制到剪贴板。",
            "successText": "一封包含您凭证的邮件已成功发送到您的邮箱地址",
            "actions": "行动"
        },
        "sso": {
            "description": "连接您组织的身份提供商以启用基于 SSO 的登录。",
            "microsoftEntraId": "Microsoft EntraID",
            "tenantId": "租户 ID：",
            "clientId": "客户端 ID：",
            "redirectURI": "重定向 URI：",
            "groupClaimMappings": "组声明映射",
            "autoAssign": "根据 Ide 令牌中的声明自动将用户分配到 组。",
            "setupGroupClaims": "设置组声明",
            "noIdentityProviderConfigured": "未配置身份提供商",
            "contact": "请联系 dih.support{'@'}telekom.com 以配置外部身份提供商。",
            "claimName": "請求名",
            "mappings": "映射",
            "idpClaimValue": "Identity Provider 索赔价值",
            "dihGroups": "组",
            "groupMappingDisclaimer": "所有映射用户默认获得业务用户角色。",
            "groupClaimNameDescription": "将Identity Provider令牌中的组值映射到 门户中的组。",
            "claimNameDisclaimer": "Identity Provider令牌中携带组值的密钥。",
            "claimNameLabel": "组在令牌中申报名称*",
            "noMappingHeading": "尚未定义映射",
            "noMappingSubheading": "添加映射以自动将用户分配到 组。",
            "addMapping": "添加映射",
            "businessUserDisclaimer": "所有映射用户默认被分配为Business-User。",
            "businessUserDisclaimer2": "角色分配是单独管理的。",
            "reviewChanges": "评论变更",
            "confirmSave": "确认并保存",
            "confirmModalDisclaimer1": "更改将在保存后下一次用户登录时生效。",
            "confirmModalDisclaimer2": "当前分配的用户直到下一次登录才会被移除。",
            "confirmBeforeSaving": "保存前请确认以下映射更改。"
        }
    },
    "completeInviteProfile": {
        "title": "完成您的账户",
        "description": "您已被邀请加入 Telekom 数据智能中心。要完成您的账户，请填写所需信息。",
        "firstName": "名字",
        "firstNamePlaceholder": "请输入您的名字",
        "lastName": "姓氏",
        "lastNamePlaceholder": "请输入您的姓氏",
        "email": "电子邮件",
        "emailPlaceholder": "请输入电子邮件地址",
        "organisation": "组织",
        "organisationPlaceholder": "请输入您的组织",
        "enterPassword": "输入密码",
        "dataPrivacyCheck": "我同意根据 {dataAndPrivacyStatement} 中所述的目的存储和处理我的个人数据。*",
        "termsAndConditionsCheck": "我确认已阅读并将遵守数据智能中心的 {termsandcondition}。",
        "termsandcondition": "条款与条件",
        "dataAndPrivacyStatement": "数据隐私声明",
        "cancel": "取消",
        "submit": "提交",
        "success": {
            "title": "您的账户已完成",
            "description": "您将被重定向到登录页面",
            "actionContinue": "继续"
        }
    },
    "workbench": {
        "incomingDataAgreements": {
            "title": "传入的数据协议",
            "addedOn": "添加时间",
            "expiresOn": "过期时间",
            "providedBy": "提供方",
            "dateAddedOn": "添加日期",
            "noFilesAttached": "目前没有附件与此协议相关联",
            "noAgreementsMessage": "您没有传入的数据协议",
            "receivingData": "正在接收数据",
            "dataReceived": "已下载",
            "error": "发生错误",
            "transferInitiated": "传输已启动",
            "transferCompleted": "传输已完成！",
            "view": "查看",
            "successDownload": "数据资产接收成功",
            "errorDownload": "下载文件 {filename} 时发生错误，请重试",
            "viewAggreement": "查看协议",
            "agreeText": "通过下载这些文件，您同意遵守本协议的 {contractTerms}",
            "contractTerms": "合同条款",
            "includedFile": "包含的文件",
            "createdOn": "创建时间",
            "fileType": "文件类型",
            "downloadError": "获取传入数据协议失败",
            "downloadSuccess": "数据资产接收成功"
        },
        "contractDetails": {
            "termsAndPolicies": "条款与政策",
            "offerBy": "提供方",
            "addedOn": "添加时间",
            "expiresOn": "过期时间",
            "product": "产品",
            "totalFiles": "文件总数",
            "description": "描述",
            "contractID": "合同编号",
            "contractTerms": "合同条款",
            "files": "文件",
            "parameters": "参数",
            "referencePeriod": "参考期间",
            "location": "位置",
            "additionalLinks": "附加链接",
            "dihMainPage": "数据智能中心主页",
            "download": "下载",
            "search": "搜索",
            "title": "标题",
            "createdOn": "创建时间",
            "kpiName": "KPI 名称",
            "fileType": "文件类型",
            "schema": "数据结构",
            "dashboard": "仪表板",
            "selectAll": "全选",
            "deselectAll": "取消全选",
            "transfer": "传输",
            "downloadSelected": "下载所选项",
            "noTermsPolicy": "目前，数据提供方尚未指定本合同中数据使用的任何规则。",
            "youCan": "您可以",
            "youCant": "您不能",
            "youMust": "您必须",
            "respectContent": "遵守许可协议内容",
            "licenceAgreement": "许可协议",
            "noAttachment": "尚无附件",
            "termsandcondition": "条款与条件",
            "resellData": "转售数据",
            "youCanUseDataCommercial": "将数据用于商业目的",
            "youCanProcessData": "在欧盟以外的基础设施上处理数据",
            "youCanEmpty": "目前，数据提供方尚未指定本合同中数据使用的任何许可",
            "youCantEmpty": "目前，数据提供方尚未指定本合同中数据使用的任何禁止行为",
            "youMustEmpty": "目前，数据提供方尚未指定本合同中数据使用的任何义务"
        }
    },
    "messages": {
        "noDataAvailable": "无可用数据",
        "noMatchFound": "未找到匹配项",
        "maximumFileSize": "最大文件大小",
        "suitableFileFormats": "适用的文件格式",
        "loading": "加载中...",
        "dragDropText": "或将文件拖放到此处"
    },
    "pageNotFound": {
        "title": "哎呀！您访问的页面似乎尚不存在。",
        "subtitle": "与此同时，您可以查看我们的其他资源，也许对您有帮助！"
    },
    "unauthorized": {
        "pageNotAccessible": "哎呀！您没有权限访问此页面。",
        "reachOutToAdministrator": "请联系您的管理员以获取更多访问权限信息。",
        "checkOtherResources": "与此同时，请查看我们的其他资源。"
    },
    "helpResources": {
        "needHelp": "需要帮助选择合适的方案、获取更多信息或技术支持？",
        "FAQ": "常见问题",
        "FAQDescription": "从账单到隐私的常见问题解答",
        "browse": "浏览",
        "demos": "演示",
        "demosDescription": "查找与您所在行业相关的用例和演示",
        "glossary": "术语表",
        "glossaryDescription": "查找与数据智能中心、IDSA、Catena-X、Gaia-X 等相关的术语和定义。"
    },
    "feedbackCard": {
        "giveUsFeedback": "告诉我们您还想要哪些内容？",
        "contactUs": "联系我们"
    },
    "requestDataspaceJoin": {
        "title": "请求连接到 {dsName}",
        "basic": "基本信息",
        "orgName": "组织名称：",
        "contact": "联系方式",
        "address": "地址：",
        "name": "姓名：",
        "email": "电子邮件：",
        "joinReasonTitle": "请说明您为什么想加入此数据空间？",
        "joinConsent": "我同意将上述信息分享给数据空间所有者",
        "sendRequest": "发送请求"
    },
    "applications": {
        "myApplication": "我的应用"
    },
    "externalConnection": {
        "title": "外部连接管理器",
        "noConnectionConfigureTitle": {
            "title": "您尚未配置任何连接",
            "newConnection": "新建连接"
        },
        "request": {
            "connectionDetails": "连接详情",
            "preferConnection": "选择服务器连接的首选模式",
            "selectConnection": "选择连接",
            "ageeTerms": "本人在此确认上述所有个人信息和数据均为准确无误",
            "grantConsent": "本人同意电信数据智能中心处理和存储上述数据，以通过所提供的连接进行资产传输",
            "back": "返回",
            "addConnection": "添加连接",
            "save": "保存",
            "verifyConnectivity": "验证连接",
            "checkingConnection": "正在检查连接",
            "connectionVerified": "连接已验证",
            "error": "错误",
            "requestSuccessTitle": "添加成功！",
            "requestSuccessText": "您已成功添加连接详情。",
            "requestUpdatedTitle": "更新成功！",
            "requestUpdatedText": "您已成功更新连接详情。",
            "maxConnectionReached": "您已达到免费连接数量上限。"
        },
        "delete": {
            "title": "删除连接",
            "description": "您确定要删除此连接吗？",
            "cancel": "取消",
            "delete": "删除",
            "requestDeleteSuccessTitle": "删除成功！",
            "requestDeleteSuccessText": "您已成功删除连接。"
        },
        "transfer": {
            "title": "连接管理器",
            "connectionDetails": "连接详情",
            "type": "类型",
            "hostName": "主机名",
            "rootPath": "根路径",
            "authType": "认证类型",
            "username": "用户名",
            "verificationStatus": "验证状态",
            "disclaimer": "免责声明",
            "disclaimerText": "确认您的选择即表示您理解所选连接不受电信数据智能中心控制。因此，您将承担因外部因素导致的数据传输问题的责任，包括但不限于存储不足、网络连接问题、访问及身份验证限制等相关因素。",
            "confirmSelection": "确认选择",
            "newConnection": "新建连接",
            "noConnectionModalTitle": "您还没有任何连接",
            "noConnectionModalDesc": "您可以点击下方按钮创建新连接。",
            "noConnectionAddNewButton": "添加新连接",
            "successModalTitle": "传输时间将比平时更长",
            "successModalDesc": "文件传输完成后我们将发送通知。",
            "successModalAction": "前往数据接收"
        }
    },
    "error": {
        "pageNotFound": "页面未找到 (404)",
        "unauthorized": "未授权访问 (403)"
    },
    "helpWidget": {
        "askSupport": "请求支持",
        "chatboxTitle": "帮助聊天",
        "chatboxSubtitle": "Telekom 数据智能中心支持",
        "defaultMessage": {
            "body": "您好，欢迎来到 Telekom 数据智能中心支持频道。请选择以下一个选项。"
        },
        "whatCanWeHelpWith": "我们今天可以为您提供什么帮助？",
        "suggestedAnswers": {
            "knowledgeBase": "知识库、文档和常见问题",
            "contactSupport": "联系支持",
            "contactSales": "联系销售"
        }
    },
    "partnerNetworkManagement": {
        "title": "合作伙伴网络管理",
        "hint": "此页面允许用户邀请并监控您合作组织在 Telekom 数据智能中心的邀请状态",
        "noInvitations": {
            "title": "您尚未邀请任何组织",
            "actionButtonText": "邀请一个组织"
        },
        "overview": {
            "title": "合作伙伴邀请概览",
            "actionButtonText": "邀请组织",
            "dateOfInvitation": "邀请日期",
            "resendInvitation": "重新发送邀请",
            "deleteInvitation": "删除邀请",
            "resendReminderInfo": "您可以在上次邀请邮件发送 24 小时后重新发送邀请。",
            "invitedBy": "邀请人"
        },
        "information": {
            "title": "重要信息",
            "description": "联系人将在 Telekom 数据智能中心中担任“管理员”角色。作为管理员，他们有权添加或移除组织成员，管理角色，并就我们提供的服务做出商业决策。我们将通过电子邮件向联系人传达组织入驻的下一步步骤，您可以在“合作伙伴邀请概览”页面监控进展。"
        },
        "invite": {
            "additionalText": "请考虑您是想逐个邀请组织，还是批量邀请 - 然后做出选择。",
            "bulkInvite": "批量邀请",
            "bulkInviteHint": "如果您希望进行批量邀请（超过 5 个），请选择此选项。",
            "limitationHint": "限制：最多 5 个组织。要添加更多，请选择“批量邀请”",
            "singleInvite": "单个邀请",
            "singleInviteHint": "如果要邀请 5 个或更少的组织，请选择此选项。",
            "orgNameLabel": "输入合作组织名称",
            "emailLabel": "输入联系人电子邮件地址",
            "groupInvite": "组邀请",
            "groupInviteHint": "如果您希望邀请多个组，请选择此选项。",
            "groupInviteInfo": "您可以添加多个群组。限制：最多可添加 5 个群组邀请。",
            "groupDetails": "群组详情：",
            "groupSelect": "请选择要添加的群组",
            "groupRequired": "群组名称为必填项",
            "groupUnique": "该群组已被添加",
            "groupCreate": "+ 创建新群组"
        },
        "inviteStatus": {
            "INVITED": "已邀请",
            "COMPLETED": "已接受",
            "FAILED": "已拒绝"
        },
        "upload": {
            "hint": "要邀请多个组织，请按照以下步骤操作：",
            "step1": "从下方链接下载模板文件",
            "step2": "在提供的文件中填写被邀请人的详细信息",
            "step3": "在指定区域上传文件",
            "downloadTemplate": "下载模板",
            "templateHeader": {
                "organizationName": "organization_name",
                "email": "email"
            },
            "templateFileName": "bulk_invitations_template.csv",
            "learnMore": "如果您想了解更多有关批量邀请的信息，请{clickHere}。",
            "clickHere": "点击这里"
        },
        "report": {
            "invitationsInProgress": "{type}邀请正在处理中",
            "invitationsSent": "邀请已发送",
            "error": {
                "errorsInInvitations": "在发送的 {result} 个邀请中存在错误",
                "single": {
                    "invalidEmail": "电子邮件地址无效",
                    "pleaseEnterValidEmail": "请输入有效的电子邮件地址",
                    "pleaseEnterValidOrganization": "组织名称字段只能包含字母、数字、空格以及以下字符：& _ . - ' , ( ) +",
                    "emailUnique": "电子邮件必须唯一",
                    "pleaseEnterValidName": "请输入有效的名称"
                },
                "bulk": {
                    "allowedFileExtension": "仅允许上传 .csv 格式的文件",
                    "fileIsTooBig": "文件太大。最大支持上传 1 MB 的文件",
                    "formatMismatch": "文件格式不符合要求。请使用提供的模板并重试",
                    "duplicateEmail": "文件中有 {number} 个{duplicate}",
                    "duplicate": "重复项 | 重复项",
                    "fileHasNoEntries": "文件中没有条目",
                    "invalidEmailAddresses": "{number} 个电子邮件地址无效。",
                    "invalidOrganizationNames": "{number} 个组织名称无效。",
                    "organizationAlreadyInvited": "{number} 个组织已被您的组织邀请过。",
                    "kindlyDownloadReport": "请下载报告以查看更多详情",
                    "limitExceededError": "您已超出合同协议规定的最大连接器配额。您只能邀请 {limit} 个参与者。请联系 {email} 修改合同并增加配额。此外，您可以撤销待处理的邀请以释放配额。",
                    "noQuotaLeftError": "您已用尽合同协议规定的最大连接器配额。您无法再邀请参与者。请联系 {email} 修改合同并增加配额。此外，您可以撤销待处理的邀请以释放配额。"
                },
                "processing": {
                    "DUPLICATE_EMAILS": "检测到重复的电子邮件。",
                    "EMAIL_ALREADY_EXIST": "电子邮件已存在。",
                    "SOMETHING_WENT_WRONG": "发生了错误。",
                    "INVALID_EMAIL_FORMAT": "电子邮件格式无效。",
                    "ALREADY_REGISTERED_DATASPACE_USER": "用户已经是 {dataspaceName} 的一员。"
                }
            },
            "template": {
                "fileName": "bulk_invitations_report.csv"
            }
        },
        "abort": {
            "title": "中止邀请",
            "confirmText": "您确定要终止该流程吗？",
            "informationText": "您的邀请将不会被发送。"
        },
        "switchForm": {
            "title": "放弃更改",
            "confirmText": "您确定要切换表单吗？",
            "informationText": "您的更改将不会被保留。"
        }
    },
    "discover": {
        "welcome": {
            "title": "发现来自我们可信合作伙伴和提供商的数据产品",
            "description1": "做出数据驱动的决策。",
            "description2": "数据在企业运营中扮演着关键角色，承担着多种重要职能，如决策支持、市场细分、潜在客户生成等。数据能够决定产品开发的成败、优化供应链物流，或为您的人工智能提供关键洞察，帮助您实现业务目标。",
            "description3": "在 Telekom 数据智能中心，我们为德国的数据提供商提供统一平台。探索各种数据产品并深入了解：您也许会发现极其契合您需求的数据方案。我们持续扩展数据提供商网络，即使当前产品尚未完全满足您的需求，也欢迎联系我们：您的理想数据产品可能就在不远的将来上线。",
            "buttonLabel": "探索数据产品"
        },
        "dataOffers": {
            "title": "数据产品",
            "filter": {
                "subjectAreas": "主题领域",
                "dataOfferingType": "数据产品类型",
                "dataProvider": "数据提供商"
            },
            "tiles": {
                "productType": "可配置数据产品",
                "dataspaceName": "数据智能中心数据空间",
                "subjectArea": "主题领域",
                "massmovementAnalytics": "群体移动分析",
                "termsOfUse": "使用条款",
                "licensedRestricted": "已授权，受限",
                "viewOffer": "查看产品",
                "product1": {
                    "name": "由 Motion Data 提供的交通分析",
                    "summary": "德国的详细移动行为统计数据，包括移动方向、起点和目的地，支持在任意地区不同空间层级上的分析。"
                },
                "product2": {
                    "name": "由 Motion Data 提供的交通分析 PRO",
                    "summary": "德国的详细移动数据测量，包括移动方向、起点和目的地，支持在不同空间层级间进行分析和比较，任何时间、任何地区皆可使用。"
                },
                "product3": {
                    "name": "由 Motion Data 提供的访客分析 PRO",
                    "summary": "分析公共流动模式下的访客行为信息，包括每日和每小时的总用户数量、社会人口统计信息，以及访客来源地详情。通过结合大样本量和前所未有的空间精度，为现场访客行为分析提供下一阶段的分析能力。"
                }
            },
            "offerDetails": {
                "title": "产品详情",
                "requestADemo": "申请演示",
                "orderNow": "立即订购",
                "productOverview": {
                    "title": "产品概览",
                    "whatUseCasesAreAddressed": "可应用的场景包括：",
                    "exampleCarousel1": {
                        "title": "大型活动评估",
                        "text": "深入了解活动参与者，优化物流策略、选择合适的活动供应商和赞助商，并依据高空间分辨率的群体密度数据，优先保障安保措施。"
                    },
                    "exampleCarousel2": {
                        "title": "旅游规划洞察",
                        "text": "旅游部门可利用访客数据优化资源分配，提升旅游热点的基础设施建设，例如根据高峰时段客流实施无缝交通网络，开展精准营销并规划应急服务。"
                    },
                    "exampleCarousel3": {
                        "title": "购物中心与零售业务洞察",
                        "text": "零售洞察揭示购物中心、商圈或商业街吸引的潜在客户数量及来源，了解停留时间、社会人口结构与消费能力。通过长期分析行为趋势，还能评估是否存在更佳选址，并比较竞争对手情况。"
                    },
                    "exampleCarousel4": {
                        "title": "城市规划与评估",
                        "text": "分析动态人口数据有助于高效规划住宅和基础设施，满足居民需求。资源的高效利用也是关键方向，城市可据此减少能源消耗，实现可持续发展目标。"
                    },
                    "fromDataIntelligenceHub": {
                        "title": "通过 Telekom 数据智能中心，您将获得：",
                        "ol": {
                            "1": "可向数据提供商（T-Systems International GmbH 的 Motion Data）申请演示，并从我们的专业顾问处获得数据产品的深入洞察。",
                            "2": "针对可订购的数据产品："
                        },
                        "ul": {
                            "1": "您将按所选时间段、地点及指标收到 CSV 格式的报告数据。",
                            "2": "可使用“Connect & Integrate”应用程序连接至数据提供商并访问所购报告。",
                            "3": "报告可在“Connect & Integrate”的“Consume”视图中下载。",
                            "4": "可向 Motion Data 申请仪表盘分析解决方案。",
                            "5": "提供工作时间内德语与英语的邮件及热线客服支持。"
                        }
                    }
                },
                "generalInformation": {
                    "availability": "数据时间范围",
                    "contactProvider": "联系数据提供商",
                    "coverage": "地理覆盖范围",
                    "documentation": "产品文档",
                    "guide": "入门指南",
                    "help": "帮助",
                    "message": {
                        "coverage": "想购买其他国家的访客信息？{link}",
                        "coverageLinkText": "联系我们",
                        "segmentation": "请查看 {link} 了解更多信息。",
                        "segmentationLinkText": "我们的知识库"
                    },
                    "missing": {
                        "availability": "无数据",
                        "coverage": "未指定地理覆盖范围。",
                        "description": "暂无描述。",
                        "provider": "未知提供商。",
                        "segmentation": "无空间分割数据。",
                        "source": "无数据源信息。",
                        "visualization": "无可视化数据。"
                    },
                    "mockData": {
                        "dataSpace": "数据智能中心数据空间",
                        "dataProvider": "T-Systems International GmbH 的 MotionData",
                        "dataSource": "德国 Deutsche Telekom 网络中用户（含漫游用户）匿名、聚合的移动信令数据（主动及被动）。",
                        "dataVisualization": "可视化仪表盘由数据提供商按需提供。",
                        "description": "访客分析提供德国任意地点的现场行为分析能力。基于 Deutsche Telekom 提供的历史匿名移动信令数据，结合大样本量与卓越空间精度，帮助企业与机构制定优化增长策略，实现智能数据驱动决策。数据以 CSV 报告形式提供，通过可信连接器解决方案经数据智能中心数据空间交付。",
                        "from": "2024年7月1日",
                        "geographicalCoverage": "德国",
                        "geoLocationData": "地理定位数据",
                        "location": "德国法兰克福",
                        "locationType": "总部",
                        "logo": "testLogoString",
                        "massMovementAnalytics": "群体移动分析",
                        "spatialSegmentation": "任意位置（由多边形或 x/y 坐标定义），缓冲区为 150 米 / 300 米。",
                        "to": "现在",
                        "verificationLabel": "由 T-Systems Gaia-X 数字清算节点认证的法人实体"
                    },
                    "provider": "数据提供商",
                    "segmentation": "空间分割",
                    "source": "数据来源",
                    "title": "基本信息",
                    "visualization": "数据可视化"
                },
                "sampleData": {
                    "title": "样本数据",
                    "dataPackage": "数据包",
                    "description": "描述",
                    "descriptionText": "基于时间的唯一访客数量（每日或每小时），以及按年龄、性别、邮政编码/地区与漫游情况划分的每日访客统计数据。",
                    "sampleDataFile": "样本数据文件",
                    "sampleDataFileDescription": "提供兴趣点（POI）上每日唯一访客数量",
                    "schemaInformation": "数据结构信息",
                    "referenceDocumentation": "参考文档",
                    "totalFiles": "数据文件总数",
                    "fileName": {
                        "pointsOfInterest": "兴趣点",
                        "productDescription": "产品描述",
                        "referenceShape": "参考图形文件",
                        "reports": "报告",
                        "roamerReference": "漫游参考说明"
                    }
                },
                "termsOfUse": {
                    "allowed": "您可以：",
                    "mandatory": "您必须：",
                    "mockData": {
                        "mock1": "将数据用于商业用途",
                        "mock2": "在欧盟以外的基础设施上处理数据",
                        "mock3": "转售数据",
                        "mock4": "遵守许可协议内容",
                        "mock5": "通用条款与条件_英文",
                        "mock6": "通用条款与条件_德文"
                    },
                    "notAllowed": "您不能：",
                    "title": "使用条款"
                },
                "additionalInformation": {
                    "label": "字段标签：",
                    "mockData": {
                        "description": "Description of a metadata block. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."
                    },
                    "title": "附加信息"
                }
            },
            "orderVAPro": {
                "title": "做出数据驱动的决策！",
                "step1SubTitle": "根据提供商请求的字段配置您的数据报价",
                "step2SubTitle": "提供区域规格信息",
                "step1of4": "第 1 步，共 4 步",
                "step2of4": "第 2 步，共 4 步",
                "step3of4": "第 3 步，共 4 步",
                "step4of4": "第 4 步，共 4 步",
                "features": {
                  "title": "访客分析专业版",
                  "feature1": "高分辨率支持高达 150m 半径的预定义多边形",
                  "feature2": "选择多天，每个订单可以多边形",
                  "feature3": "产品包括独立访客数量和其他关键指标的每小时和每日数据",
                  "feature4": "仪表板和咨询可应要求提供",
                  "feature5": "通过受信任的 Connect and Integrate 解决方案无缝、安全地交付数据文件的模式。"
                },
                "dateTitle": "时间范围",
                "dateTooltip": "指定要分析 Visitor Analytics Pro 报告的时间范围至少为 1 天。时间范围是指收集、测量和处理数据并准备进行分析的时期",
                "areaSelectionTitle": "区域选择",
                "areaSelectionTooltip": "数据分布中的区域选择涉及缩小数据集范围，以仅包括与特定感兴趣地理区域相关的观测值或测量值。",
                "validDays": "有效天数总数：",
                "segmentTypeLabel": "选择空间分割类型",
                "informationTypeLabel": "您希望如何提供此信息",
                "totolPOICount": "POI 总数：",
                "confirmSelection": "确认选择",
                "totalPOICounts": "POI 总数：",
                "priceFetchingProgressMsg": "我们正在获取您的价格...",
                "priceFetchingError": "无法获取您的价格",
                "totalPriceText": "总价：",
                "vatText": "（不含增值税）",
                "premiumCustomerHighlight": "订单金额超过 10.000 欧元，您就是我们的高级客户。我们将通过另一封电子邮件与您联系，讨论进一步的合作方案。",
                "reviewPageHeading": "订单摘要",
                "name": "名称",
                "monthlyCharges": "月度费用",
                "oneTimeCharges": "一次性收费",
                "yourSelectedProduct": "您选择的产品",
                "product": "产品",
                "timeSelection": "时间选择",
                "type": "类型：",
                "areaSelection": "区域选择",
                "spatialInput": "空间输入：兴趣点 (POI)",
                "inputType": "输入类型：选择预定义的 POI",
                "viewMap": "查看地图",
                "additionalServices": "附加服务",
                "supportServices": "支持服务",
                "essentialSupport": "基本支持 5/8",
                "totalAmount": "总金额（欧元）",
                "resultSuccessHeading": "感谢您下订单",
                "resultParaText1": "您的文件将很快可用，感谢您的耐心等待。",
                "resultParaText2": "如果您有任何问题或疑问，请随时与我们联系。",
                "membershipBtn": "转到我的会员资格",
                "mapPoi": "POI: ",
                "mapCity": "城市: ",
                "mapCoordinates": "坐标: ",
                "pickDate": "选择一个日期",
                "from": "from",
                "to": "致",
                "selectDate": "选择一个日期",
                "poiDropdown": "兴趣点 (POI)",
                "mapSelection": "在地图上选择兴趣点 (POI)",
                "fileUpload": "上传首选 POI 的 shapefile",
                "predefinedSelection": "选择预定义的兴趣点"
            }
        }
    },
    "ospOnboarding": {
        "help": "帮助",
        "welcome": {
            "title": "欢迎加入 Catena-X —— 汽车网络",
            "card": {
                "note": "请完成以下申请表，以完成您公司在 Catena-X 的注册",
                "point-1": "注册表格共包含 3 个步骤，预计需要约 5-10 分钟",
                "point-2": "由于您的组织已在 Telekom 数据智能中心注册，我们将自动预填已有数据，以便您顺利完成流程。",
                "point-3": "您可以随时在我们的知识库中查看帮助指南，以更好地了解注册流程。请点击 {hereLink} 了解更多信息。",
                "here": "这里",
                "letStarted": "开始吧"
            }
        },
        "title": "注册加入 Catena-X 生态系统",
        "description": "通过以下三个步骤填写所有所需信息，注册加入 Catena-X。",
        "description2": "请完成以下任务以完成公司入驻流程，参与并使用 Catena-X 汽车网络门户中的所有功能。",
        "note": "请在继续前输入所有必填信息。更多信息请查看我们的 {help} 部分。",
        "companyDataStepTitle": "公司信息",
        "companyRoleStepTitle": "公司角色",
        "verifyAndSubmitStepTitle": "验证并提交",
        "companyData": {
            "title": "添加公司信息",
            "description": "请在下方填写您公司的法人实体信息。带有 (*) 标记的字段为必填项，表单将根据您在入驻过程中提供的信息自动预填。",
            "organizationName": "组织名称",
            "organizationNameTooltip": "注册的组织名称",
            "enterYourData": "请输入您的数据",
            "bpn": "业务合作伙伴编号",
            "bpnTooltip": "业务合作伙伴编号（BPN）是在 Catena-X 生态系统中分配给每个业务合作伙伴的唯一标识符。",
            "legalEntityName": "法人实体名称",
            "transliteratedName": "音译名称 (拉丁字符)",
            "registeredName": "注册名称",
            "orgAddress": "组织地址",
            "streetName": "街道名称",
            "houseNumber": "门牌号",
            "postCode": "邮政编码",
            "city": "城市",
            "countryCode": "国家代码",
            "region": "地区",
            "companyIdentifier": "公司标识符",
            "identifierType": "标识符类型",
            "identifierNumber": "标识符编号",
            "contactInfo": "联系信息",
            "emailAddress": "电子邮件地址",
            "userRole": "用户角色",
            "CRN": {
                "label": "商业登记号码",
                "helpText": "示例：HRB 55933",
                "tooltipText": "商业登记号码（CRN）是用于公司法律商业注册的唯一标识符，用于通过可信数据源验证公司的注册和财务交易信息的真实性。"
            },
            "vatId": {
                "label": "增值税号码",
                "helpText": "示例：DE 118 645 675",
                "tooltipText": "增值税号（VAT ID）是为企业税务目的分配的唯一标识符。"
            }
        },
        "companyRole": {
            "title": "贵公司的角色",
            "description": "请选择一个或多个您希望在 Catena-X 网络中扮演的公司角色。公司角色可以在之后进行更新/更改。根据所选角色，门户所提供的服务也可能有所不同。",
            "activeParticipanyNote": "通过 T-Systems 的 Connect & Integrate 定制并优化您在 Catena-X 的参与方式，实现轻松自动接入。可在 Cofinity 应用商城订购 Connect & Integrate，以立即开始数据交换！起价 49 欧元/月，适用于所有行业规模。",
            "agreeTermsCheckbox": "是的，我同意所选角色的 {link}",
            "activeParticipantNote": {
                "para1": "通过 {link} 定制并优化您在 Catena-X 中的参与方式，实现轻松自动接入。",
                "tSystemsConnectAndIntegrate": "T-Systems 的 Connect & Integrate",
                "para2": "可在 Cofinity 应用商城订购 Connect & Integrate，用于主流 Catena-X 使用场景，立即开始数据交换！",
                "para3": "起价 {price}/月，适用于所有行业规模。"
            },
            "appProviderNote": {
                "para1": "{link} 让您能够在我们的官方 Catena-X Sandbox 环境中开发、管理和认证商业应用程序。",
                "para2": "立即订购 Build & Operate，让我们为您处理数据空间基础设施，您可专注于创新！",
                "para1PlaceholderLink": "T-Systems 的 Build & Operate",
                "optionalInformation": "可选信息"
            }
        },
        "verifyAndSubmit": {
            "title": "验证您的注册信息",
            "description": "请在提交注册前验证贵公司的注册信息，确保所有信息填写准确无误。验证无误后，请点击下方“提交”按钮提交注册申请以供审批。",
            "companyData": "公司信息",
            "activeRole": "当前角色",
            "consentText": "本人同意 T-Systems International GmbH 向 Cofinity-X GmbH 提交我的注册申请，并处理相关个人数据，以完成入驻流程及相关事项。本人知晓数据处理将依据适用的数据保护法律法规（包括但不限于《通用数据保护条例》（GDPR））进行。本人理解，个人数据仅在达成目的所需的时间范围内被存储。本人知晓，此同意是与 Cofinity-X GmbH 注册和入驻所必需的，我可随时撤回同意，且该撤回将自未来生效。"
        },
        "actions": {
            "back": "返回",
            "next": "下一步",
            "submit": "提交"
        },
        "validation": {
            "DE_COMMERCIAL_REG_NUMBER": "请输入有效号码。提示：包含连字符和空格的字母数字组合，恰好 9 位。",
            "DE_VAT_ID": "请输入有效号码。提示：以 DE 开头，后接 9 位数字。",
            "Worldwide_COMMERCIAL_REG_NUMBER": "请输入有效号码。提示：包含连字符的字母数字组合，6 至 21 位。",
            "Worldwide_VAT_ID": "请输入有效号码。提示：包含连字符和空格的字母数字组合，8 至 15 位。",
            "invalid_bpn": "无效的 BPN 编号。BPN 编号必须以 BPNL 开头，后接 12 位字母或数字。"
        },
        "error": {
            "title": "验证错误",
            "para": "您的组织可能已存在于 Cofinity-X 网络中，或当前存在技术问题。请告诉我们您的体验详情，以便我们进一步协助您。",
            "buttonText": "联系我们"
        },
        "success": {
            "title": "感谢您提交申请",
            "para": "您的信息已发送至 Cofinity-X，后续步骤将通过电子邮件告知。",
            "buttonText": "前往首页"
        }
    },
    "demoOrg": {
        "title": "演示组织",
        "tooltip": "这是一个演示/评估组织。",
        "tooltip1": "部分功能可能受限。"
    }
}